export default [
	{
			"categoryName": "对话聊天",
			"clientUserThirdPartyAccountResponses": [
					{
							"platformName": "通义",
							"intro": "阿里推出的基于通义大模型的AI助手",
							"link": "https://tongyi.aliyun.com/",
							"logo": "tongyi-aliyun-icon.png",
							"sort": 1,
							"instructions": "<h3><br></h3>",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#B03A2E", // 修改为较暗的颜色
							"avatarName": "通", // platformName的第一个字
							"avatarColor": "#F5F5F5" // 修改为较浅的对比色
					},
					{
							"platformName": "Kimi智能助手",
							"intro": "拥有强大的长文本处理能力的AI助手",
							"link": "https://kimi.moonshot.cn/?utm_campaign=TR_BY83xOmA&utm_content=&utm_medium=CPA&utm_source=CH_VmpNgGW9&utm_term=",
							"logo": "kimi-ai-logo.png",
							"sort": 2,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#1F618D", // 修改为较暗的颜色
							"avatarName": "K", // platformName的第一个字
							"avatarColor": "#FFFFFF" // 保持对比色
					},
					{
							"platformName": "腾讯元宝",
							"intro": "腾讯推出的免费AI智能助手",
							"link": "https://yuanbao.tencent.com/?utm_source=huyaai.cn",
							"logo": "tencent-yuanbao-icon.png",
							"sort": 3,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#5D6D7E", // 修改为较暗的颜色
							"avatarName": "腾", // platformName的第一个字
							"avatarColor": "#F0F3F4" // 修改为较浅的对比色
					},
					{
							"platformName": "文小言",
							"intro": "百度推出的基于文心大模型的AI对话互动工具",
							"link": "https://yiyan.baidu.com/",
							"logo": "baidu-yiyan-icon.png",
							"sort": 4,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#A569BD", // 修改为较暗的颜色
							"avatarName": "文", // platformName的第一个字
							"avatarColor": "#FFFFFF" // 保持对比色
					},
					{
							"platformName": "智谱清言",
							"intro": "基于GLM开源大模型的AI助手",
							"link": "https://chatglm.cn/",
							"logo": "zhipu-ai-chatglm-icon.png",
							"sort": 5,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#F39C12", // 修改为较暗的颜色
							"avatarName": "智", // platformName的第一个字
							"avatarColor": "#FFFFFF" // 保持对比色
					},
					{
							"platformName": "豆包",
							"intro": "字节跳动推出的免费AI对话助手",
							"link": "https://www.doubao.com/chat/",
							"logo": "doubao-icon.png",
							"sort": 6,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#A2D9CE", // 修改为较暗的颜色
							"avatarName": "豆", // platformName的第一个字
							"avatarColor": "#000000" // 保持对比色
					},
					{
							"platformName": "通义星尘",
							"intro": "阿里推出的类人智能体/数字分身创作平台",
							"link": "https://tongyi.aliyun.com/xingchen/?utm_source=huyaai.cn",
							"logo": "tongyi-icon.png",
							"sort": 7,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#B03A2E", // 修改为较暗的颜色
							"avatarName": "通", // platformName的第一个字
							"avatarColor": "#F5F5F5" // 修改为较浅的对比色
					},
					{
							"platformName": "讯飞星火",
							"intro": "讯飞推出的基于星火大模型的AI助手",
							"link": "https://xinghuo.xfyun.cn/desk",
							"logo": "xunfei-xinghuo-logo.png",
							"sort": 8,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#1F618D", // 修改为较暗的颜色
							"avatarName": "讯", // platformName的第一个字
							"avatarColor": "#FFFFFF" // 保持对比色
					},
					{
							"platformName": "百小应",
							"intro": "基于Baichuan 4大模型的AI助手，能够提供智能搜索和问答。",
							"link": "https://chat.baichuan-ai.com/home?utm_source=huyaai.cn",
							"logo": "baichuan-ai-icon.png",
							"sort": 9,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#A569BD", // 修改为较暗的颜色
							"avatarName": "百", // platformName的第一个字
							"avatarColor": "#FFFFFF" // 保持对比色
					},
					// {
					// 		"platformName": "ChatGPT",
					// 		"intro": "OpenAI旗下AI对话工具",
					// 		"link": "https://cn.bing.com/search?q=ChatGPT&ensearch=1",
					// 		"logo": "chatgpt-icon.png",
					// 		"sort": 10,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#B03A2E", // 修改为较暗的颜色
					// 		"avatarName": "C", // platformName的第一个字
					// 		"avatarColor": "#F5F5F5" // 修改为较浅的对比色
					// },
					{
							"platformName": "Copilot",
							"intro": "微软推出的网页版Copilot助手",
							"link": "https://copilot.microsoft.com/",
							"logo": "microsoft-copilot-icon.png",
							"sort": 11,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#5D6D7E", // 修改为较暗的颜色
							"avatarName": "C", // platformName的第一个字
							"avatarColor": "#F0F3F4" // 修改为较浅的对比色
					},
					// {
					// 		"platformName": "Bing新必应",
					// 		"intro": "微软推出的新版结合了ChatGPT功能的必应",
					// 		"link": "https://cn.bing.com/search?q=Bing",
					// 		"logo": "new-bing-icon.png",
					// 		"sort": 12,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#B03A2E", // 修改为较暗的颜色
					// 		"avatarName": "B", // platformName的第一个字
					// 		"avatarColor": "#F5F5F5" // 修改为较浅的对比色
					// },
					// {
					// 		"platformName": "Claude",
					// 		"intro": "ChatGPT的最为有力的竞争对手之一",
					// 		"link": "https://cn.bing.com/search?q=Claude&ensearch=1",
					// 		"logo": "anthropic-icon.png",
					// 		"sort": 13,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#5D6D7E", // 修改为较暗的颜色
					// 		"avatarName": "C", // platformName的第一个字
					// 		"avatarColor": "#F0F3F4" // 修改为较浅的对比色
					// },
					// {
					// 		"platformName": "Google Bard",
					// 		"intro": "Google推出的AI聊天对话机器人Bard",
					// 		"link": "https://cn.bing.com/search?q=Google Bard&ensearch=1",
					// 		"logo": "google-bard-favicon.png",
					// 		"sort": 14,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#B03A2E", // 修改为较暗的颜色
					// 		"avatarName": "G", // platformName的第一个字
					// 		"avatarColor": "#F5F5F5" // 修改为较浅的对比色
					// },
					// {
					// 		"platformName": "百小应",
					// 		"intro": "百川智能推出的免费AI助手",
					// 		"link": "https://ying.baichuan-ai.com/chat?from=huyaai.cn",
					// 		"logo": "ying-ai-icon.png",
					// 		"sort": 15,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#5D6D7E", // 修改为较暗的颜色
					// 		"avatarName": "百", // platformName的第一个字
					// 		"avatarColor": "#F0F3F4" // 修改为较浅的对比色
					// },
					// {
					// 		"platformName": "Koko AI",
					// 		"intro": "Seele公司推出的「AI+3D」情感陪伴产品",
					// 		"link": "https://www.seeles.ai/?utm_source=huyaai.cn",
					// 		"logo": "Koko-ai-logo.png",
					// 		"sort": 16,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#B03A2E", // 修改为较暗的颜色
					// 		"avatarName": "K", // platformName的第一个字
					// 		"avatarColor": "#F5F5F5" // 修改为较浅的对比色
					// },
					// {
					// 		"platformName": "Ohai",
					// 		"intro": "月之暗面旗下推出的AI角色扮演虚拟陪伴应用",
					// 		"link": "https://beta.ohai.bot/discover?utm_source=huyaai.cn",
					// 		"logo": "ohai-icon.png",
					// 		"sort": 17,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#5D6D7E", // 修改为较暗的颜色
					// 		"avatarName": "O", // platformName的第一个字
					// 		"avatarColor": "#F0F3F4" // 修改为较浅的对比色
					// },
					// {
					// 		"platformName": "Le Chat",
					// 		"intro": "Mistral推出的AI1助手",
					// 		"link": "https://chat.mistral.ai/?ref=huyaai.cn",
					// 		"logo": "mistral-ai-icon.png",
					// 		"sort": 18,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#B03A2E", // 修改为较暗的颜色
					// 		"avatarName": "L", // platformName的第一个字
					// 		"avatarColor": "#F5F5F5" // 修改为较浅的对比色
					// },
					{
							"platformName": "海螺AI",
							"intro": "MiniMax推出的AI助手",
							"link": "https://hailuoai.com/?utm_source=huyaai.cn",
							"logo": "hailuoai-icon.png",
							"sort": 19,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#5D6D7E", // 修改为较暗的颜色
							"avatarName": "海", // platformName的第一个字
							"avatarColor": "#F0F3F4" // 修改为较浅的对比色
					},
					// {
					// 		"platformName": "Grok",
					// 		"intro": "马斯克旗下xAI推出的人工智能助手",
					// 		"link": "https://grok.x.ai/",
					// 		"logo": "xai-icon.png",
					// 		"sort": 20,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#B03A2E", // 修改为较暗的颜色
					// 		"avatarName": "G", // platformName的第一个字
					// 		"avatarColor": "#F5F5F5" // 修改为较浅的对比色
					// },
					{
							"platformName": "问小白",
							"intro": "基于元石大模型的AI对话助手",
							"link": "https://www.wenxiaobai.com/?utm_source=huyaai.cn",
							"logo": "wenxiaobai-logo.png",
							"sort": 21,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#5D6D7E", // 修改为较暗的颜色
							"avatarName": "问", // platformName的第一个字
							"avatarColor": "#F0F3F4" // 修改为较浅的对比色
					},
					// {
					// 		"platformName": "Museland",
					// 		"intro": "沉浸式AI角色扮演产品",
					// 		"link": "https://www.museland.ai/?utm_source=huyaai.cn",
					// 		"logo": "Museland-logo.png",
					// 		"sort": 22,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#B03A2E", // 修改为较暗的颜色
					// 		"avatarName": "M", // platformName的第一个字
					// 		"avatarColor": "#F5F5F5" // 修改为较浅的对比色
					// },
					{
							"platformName": "冒泡鸭",
							"intro": "面向个人用户的 AI 互动平台（剧情与角色）",
							"link": "https://maopaoya.com/?ref=huyaai.cn",
							"logo": "maopaoya-icon.png",
							"sort": 23,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#5D6D7E", // 修改为较暗的颜色
							"avatarName": "冒", // platformName的第一个字
							"avatarColor": "#F0F3F4" // 修改为较浅的对比色
					},
					{
							"platformName": "百度AI搜索",
							"intro": "百度最新上线的AI搜索对话工具",
							"link": "https://chat.baidu.com/",
							"logo": "chat-baidu-icon.png",
							"sort": 24,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#B03A2E", // 修改为较暗的颜色
							"avatarName": "百", // platformName的第一个字
							"avatarColor": "#F5F5F5" // 修改为较浅的对比色
					},
					{
							"platformName": "超级助理",
							"intro": "基于文心大模型的智能助手，含Copilot浏览器插件端和助理开发平台",
							"link": "https://cloud.baidu.com/product/infoflow.html?ref=huyaai.cn",
							"logo": "superagent-icon.png",
							"sort": 25,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#5D6D7E", // 修改为较暗的颜色
							"avatarName": "超", // platformName的第一个字
							"avatarColor": "#F0F3F4" // 修改为较浅的对比色
					},
					// {
					// 		"platformName": "钉钉·个人版",
					// 		"intro": "钉钉推出的个人版办公应用程序，内置AI智能助手，可进行AI创作、AI对话、AI绘画",
					// 		"link": "https://workspace.dingtalk.com/welcome?utm_source=huyaai.cn",
					// 		"logo": "dingtalk-personal-ai.png",
					// 		"sort": 26,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#B03A2E", // 修改为较暗的颜色
					// 		"avatarName": "钉", // platformName的第一个字
					// 		"avatarColor": "#F5F5F5" // 修改为较浅的对比色
					// },
					// {
					// 		"platformName": "Wanderboat",
					// 		"intro": "硅谷初创公司UTA AI推出的AI旅行助手",
					// 		"link": "https://wanderboat.ai/?utm_source=huyaai.cn",
					// 		"logo": "wanderboat-logo.png",
					// 		"sort": 27,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#5D6D7E", // 修改为较暗的颜色
					// 		"avatarName": "W", // platformName的第一个字
					// 		"avatarColor": "#F0F3F4" // 修改为较浅的对比色
					// },
					// {
					// 		"platformName": "MChat",
					// 		"intro": "基于孟子GPT大模型的AI对话机器人",
					// 		"link": "https://www.langboat.com/portal/mengzi-gpt?from=huyaai.cn",
					// 		"logo": "langboat-mchat-icon.png",
					// 		"sort": 28,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#B03A2E", // 修改为较暗的颜色
					// 		"avatarName": "M", // platformName的第一个字
					// 		"avatarColor": "#F5F5F5" // 修改为较浅的对比色
					// },
					{
							"platformName": "Luca面壁露卡",
							"intro": "基于 CPM 大模型的多模态智能对话助手",
							"link": "https://luca-beta.modelbest.cn/",
							"logo": "luca-modelbest-icon.png",
							"sort": 29,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#5D6D7E", // 修改为较暗的颜色
							"avatarName": "L", // platformName的第一个字
							"avatarColor": "#F0F3F4" // 修改为较浅的对比色
					},
					{
							"platformName": "元象XChat",
							"intro": "基于元象通用大模型的AI助手",
							"link": "https://chat.xverse.cn/xchat/index.html",
							"logo": "xverse-icon.png",
							"sort": 30,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#B03A2E", // 修改为较暗的颜色
							"avatarName": "元", // platformName的第一个字
							"avatarColor": "#F5F5F5" // 修改为较浅的对比色
					},
					// {
					// 		"platformName": "ChitChop",
					// 		"intro": "字节旗下面向海外用户推出的免费大模型产品和AI助手工具箱",
					// 		"link": "https://www.chitchop.com/?ref=huyaai.cn",
					// 		"logo": "chitchop-icon.png",
					// 		"sort": 2,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#5D6D7E", // 修改为较暗的颜色
					// 		"avatarName": "C", // platformName的第一个字
					// 		"avatarColor": "#F0F3F4" // 修改为较浅的对比色
					// },
					{
							"platformName": "DeepSeek",
							"intro": "深度求索推出的开源模型DeepSeek（含推理）",
							"link": "https://www.deepseek.com/?utm_source=huyaai.cn",
							"logo": "deepseek-chat-icon.png",
							"sort": 1,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#B03A2E", // 修改为较暗的颜色
							"avatarName": "D", // platformName的第一个字
							"avatarColor": "#F5F5F5" // 修改为较浅的对比色
					},
					{
							"platformName": "魔搭GPT（ModelScopeGPT）",
							"intro": "阿里达摩院推出的大小模型协同的智能助手",
							"link": "https://www.modelscope.cn/studios/damo/ModelScopeGPT",
							"logo": "modelscope-icon.png",
							"sort": 3,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#5D6D7E", // 修改为较暗的颜色
							"avatarName": "魔", // platformName的第一个字
							"avatarColor": "#F0F3F4" // 修改为较浅的对比色
					},
					// {
					// 		"platformName": "Forefront",
					// 		"intro": "提供GPT-3.5、GPT-4、Claude的AI聊天机器人",
					// 		"link": "https://cn.bing.com/search?q=Forefront&ensearch=1",
					// 		"logo": "forefront-ai-icon.png",
					// 		"sort": 4,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#B03A2E", // 修改为较暗的颜色
					// 		"avatarName": "F", // platformName的第一个字
					// 		"avatarColor": "#F5F5F5" // 修改为较浅的对比色
					// },
					{
							"platformName": "小悟空",
							"intro": "字节跳动推出的一个多功能AI对话助手和个人助理",
							"link": "https://wukong.com/tool?utm_source=huyaai.cn",
							"logo": "wukong-ai-icon.png",
							"sort": 5,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#5D6D7E", // 修改为较暗的颜色
							"avatarName": "小", // platformName的第一个字
							"avatarColor": "#F0F3F4" // 修改为较浅的对比色
					},
					{
							"platformName": "紫东太初",
							"intro": "中科院和武智院推出的多模态大模型",
							"link": "https://taichu-web.ia.ac.cn/#/welcome",
							"logo": "taichu-ai-icon.png",
							"sort": 6,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#B03A2E", // 修改为较暗的颜色
							"avatarName": "紫", // platformName的第一个字
							"avatarColor": "#F5F5F5" // 修改为较浅的对比色
					},
					// {
					// 		"platformName": "小黄蕉",
					// 		"intro": "字节跳动旗下推出的AI虚拟交友聊天平台",
					// 		"link": "https://chatwiz.cn/h5/feely?utm_source=huyaai.cn",
					// 		"logo": "chatwiz-icon.png",
					// 		"sort": 7,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#5D6D7E", // 修改为较暗的颜色
					// 		"avatarName": "小", // platformName的第一个字
					// 		"avatarColor": "#F0F3F4" // 修改为较浅的对比色
					// },
					{
							"platformName": "跃问",
							"intro": "阶跃星尘推出的基于大模型的对话助手",
							"link": "https://yuewen.cn/chats/new?utm_source=huyaai.cn&utm_content=huyaai.cn",
							"logo": "stepchat-icon.png",
							"sort": 8,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#B03A2E", // 修改为较暗的颜色
							"avatarName": "跃", // platformName的第一个字
							"avatarColor": "#F5F5F5" // 修改为较浅的对比色
					},
					// {
					// 		"platformName": "逗逗",
					// 		"intro": "专为二次元用户设计的AI桌宠应用",
					// 		"link": "https://www.doudou.fun/?utm_source=huyaai.cn",
					// 		"logo": "doudou-website.png",
					// 		"sort": 9,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#5D6D7E", // 修改为较暗的颜色
					// 		"avatarName": "逗", // platformName的第一个字
					// 		"avatarColor": "#F0F3F4" // 修改为较浅的对比色
					// },
					// {
					// 		"platformName": "Cici",
					// 		"intro": "豆包国际版，字节跳动面向海外市场推出的AI助手",
					// 		"link": "https://www.ciciai.com/browser-extension/landing/zh/?utm_source=huyaai.cn",
					// 		"logo": "doubao-icon.png",
					// 		"sort": 10,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#B03A2E", // 修改为较暗的颜色
					// 		"avatarName": "C", // platformName的第一个字
					// 		"avatarColor": "#F5F5F5" // 修改为较浅的对比色
					// },
					{
							"platformName": "商量SenseChat",
							"intro": "商汤基于SenseTime大模型推出的对话助手",
							"link": "https://chat.sensetime.com/wb/home?utm_source=huyaai.cn",
							"logo": "sensechat-new-icon.png",
							"sort": 41,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#5D6D7E", // 修改为较暗的颜色
							"avatarName": "商", // platformName的第一个字
							"avatarColor": "#F0F3F4" // 修改为较浅的对比色
					}
			]
	},
	{
			"categoryName": "提示指令",
			"clientUserThirdPartyAccountResponses": [
					// {
					// 		"platformName": "PromptPerfect",
					// 		"intro": "专业的提示词优化工具，一站式开发、优化、调试和部署提示词",
					// 		"link": "https://promptperfect.jinaai.cn/?utm_source=huyaai.cn",
					// 		"logo": "promptperfect-icon.png",
					// 		"sort": 42,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#4A4E69", // 深灰色背景
					// 		"avatarName": "P", // platformName的第一个字
					// 		"avatarColor": "#F9F7F7" // 浅色对比
					// },
					{
							"platformName": "提示工程指南",
							"intro": "来自GitHub的提示工程指南中文版",
							"link": "https://www.promptingguide.ai/zh",
							"logo": "prompt-engineering-guide-icon.png",
							"sort": 43,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#2D3E50", // 深蓝色背景
							"avatarName": "提", // platformName的第一个字
							"avatarColor": "#EAE7DC" // 浅色对比
					},
					// {
					// 		"platformName": "AIPRM",
					// 		"intro": "主要针对于SEO和SaaS文案写作的ChatGPT Prompts浏览器扩展",
					// 		"link": "https://www.aiprm.com/",
					// 		"logo": "aiprm-icon.png",
					// 		"sort": 44,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#6C757D", // 灰色背景
					// 		"avatarName": "A", // platformName的第一个字
					// 		"avatarColor": "#F8F9FA" // 浅色对比
					// },
					// {
					// 		"platformName": "绘AI",
					// 		"intro": "AI绘画提示词分享平台",
					// 		"link": "https://www.ai016.com/",
					// 		"logo": "ai016-icon.png",
					// 		"sort": 45,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#D1C4E9", // 淡紫色背景
					// 		"avatarName": "绘", // platformName的第一个字
					// 		"avatarColor": "#3E2723" // 深色对比
					// },
					// {
					// 		"platformName": "MJ Prompt Tool",
					// 		"intro": "Midjourney Prompt帮助工具",
					// 		"link": "https://prompt.noonshot.com/",
					// 		"logo": "noonshot-icon.png",
					// 		"sort": 46,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#FFABAB", // 浅红色背景
					// 		"avatarName": "M", // platformName的第一个字
					// 		"avatarColor": "#2C3E50" // 深色对比
					// },
					// {
					// 		"platformName": "Visual Prompt Builder",
					// 		"intro": "可视化AI提示语选择和搭建",
					// 		"link": "https://tools.saxifrage.xyz/prompt",
					// 		"logo": "visual-prompt-builer-icon.png",
					// 		"sort": 47,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#B2EBF2", // 浅蓝色背景
					// 		"avatarName": "V", // platformName的第一个字
					// 		"avatarColor": "#004D40" // 深色对比
					// },
					// {
					// 		"platformName": "FlowGPT",
					// 		"intro": "ChatGPT指令大全",
					// 		"link": "https://flowgpt.com/",
					// 		"logo": "flowgpt-icon.png",
					// 		"sort": 48,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#FFCCBC", // 浅橙色背景
					// 		"avatarName": "F", // platformName的第一个字
					// 		"avatarColor": "#BF360C" // 深色对比
					// },
					// {
					// 		"platformName": "Stable Diffusion Prompt Book",
					// 		"intro": "OpenArt推出的针对Stable Diffusion指令的手册",
					// 		"link": "https://openart.ai/promptbook",
					// 		"logo": "openart-ai-icon.png",
					// 		"sort": 49,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#C8E6C9", // 浅绿色背景
					// 		"avatarName": "S", // platformName的第一个字
					// 		"avatarColor": "#1B5E20" // 深色对比
					// },
					// {
					// 		"platformName": "Snack Prompt",
					// 		"intro": "探索最新的ChatGPT语义提示词",
					// 		"link": "https://snackprompt.com/?ref=huyaai.cn",
					// 		"logo": "snack-prompt-icon.png",
					// 		"sort": 50,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#FFE0B2", // 浅黄色背景
					// 		"avatarName": "S", // platformName的第一个字
					// 		"avatarColor": "#BF360C" // 深色对比
					// },
					// {
					// 		"platformName": "ChatGPT Prompt Genius",
					// 		"intro": "免费开源的ChatGPT Prompt浏览器扩展",
					// 		"link": "https://github.com/benf2004/ChatGPT-Prompt-Genius",
					// 		"logo": "chatgpt-prompt-genius-icon.png",
					// 		"sort": 51,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#E1BEE7", // 浅紫色背景
					// 		"avatarName": "C", // platformName的第一个字
					// 		"avatarColor": "#4A148C" // 深色对比
					// },
					// {
					// 		"platformName": "PromptHero",
					// 		"intro": "发现Stable Diffusion、ChatGPT和Midjourney的提示用语",
					// 		"link": "https://prompthero.com/",
					// 		"logo": "prompt-hero-icon.png",
					// 		"sort": 52,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#FFABAB", // 浅红色背景
					// 		"avatarName": "P", // platformName的第一个字
					// 		"avatarColor": "#3E2723" // 深色对比
					// },
					// {
					// 		"platformName": "ClickPrompt",
					// 		"intro": "专为 Prompt 编写者设计的工具",
					// 		"link": "https://www.clickprompt.org/zh-CN/",
					// 		"logo": "clickprompt-icon.png",
					// 		"sort": 53,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#B2DFDB", // 浅绿色背景
					// 		"avatarName": "C", // platformName的第一个字
					// 		"avatarColor": "#004D40" // 深色对比
					// },
					{
							"platformName": "Generrated",
							"intro": "DALL·E 2 或 DALL·E 3的提示设计示例",
							"link": "https://generrated.com/",
							"logo": "generrated-icon.png",
							"sort": 54,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFCCBC", // 浅橙色背景
							"avatarName": "G", // platformName的第一个字
							"avatarColor": "#BF360C" // 深色对比
					},
					{
							"platformName": "PublicPrompts",
							"intro": "图片生成的提示设计示例",
							"link": "https://publicprompts.art/",
							"logo": "public-prompts-icon.png",
							"sort": 55,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#C8E6C9", // 浅绿色背景
							"avatarName": "P", // platformName的第一个字
							"avatarColor": "#1B5E20" // 深色对比
					},
					{
							"platformName": "PromptBase",
							"intro": "AI Prompts集合市场",
							"link": "https://promptbase.com/",
							"logo": "promptbase-icon.png",
							"sort": 56,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFABAB", // 浅红色背景
							"avatarName": "P", // platformName的第一个字
							"avatarColor": "#3E2723" // 深色对比
					},
					{
							"platformName": "PromptBase",
							"intro": "高质量的提示词市场",
							"link": "https://promptvine.com/",
							"logo": "promptvine-icon.png",
							"sort": 57,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#E1BEE7", // 浅紫色背景
							"avatarName": "P", // platformName的第一个字
							"avatarColor": "#4A148C" // 深色对比
					},
					// {
					// 		"platformName": "Awesome ChatGPT Prompts",
					// 		"intro": "ChatGPT Prompts集合",
					// 		"link": "https://prompts.chat/",
					// 		"logo": "awesome-chatgpt-prompt-icon.png",
					// 		"sort": 58,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#FFCCBC", // 浅橙色背景
					// 		"avatarName": "A", // platformName的第一个字
					// 		"avatarColor": "#BF360C" // 深色对比
					// },
					{
							"platformName": "Learning Prompt",
							"intro": "免费的 Prompt Engineering 教程（中文开源）",
							"link": "https://learningprompt.wiki/",
							"logo": "learning-prompt-icon.png",
							"sort": 59,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#B2DFDB", // 浅绿色背景
							"avatarName": "学", // platformName的第一个字
							"avatarColor": "#004D40" // 深色对比
					},
					{
							"platformName": "AI Short",
							"intro": "文本生成的海量提示示例",
							"link": "https://www.aishort.top/",
							"logo": "chatgpt-shortcut-icon.png",
							"sort": 60,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFABAB", // 浅红色背景
							"avatarName": "C", // platformName的第一个字
							"avatarColor": "#3E2723" // 深色对比
					},
					// {
					// 		"platformName": "词魂",
					// 		"intro": "AIGC精品提示词库",
					// 		"link": "https://icihun.com/?ref=huyaai.cn",
					// 		"logo": "icihun-icon.png",
					// 		"sort": 61,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#C8E6C9", // 浅绿色背景
					// 		"avatarName": "词", // platformName的第一个字
					// 		"avatarColor": "#1B5E20" // 深色对比
					// },
					{
						"platformName": "Prompts.Chat",
						"intro": "类别完整的开源提示词网站",
						"link": "https://prompts.chat/",
						"logo": "",
						"sort": 62,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#1A1A1A", // 浅红色背景
						"avatarName": "P", // platformName的第一个字
						"avatarColor": "#1BAA9F" // 深色对比
					},
					{
						"platformName": "AI Prompt Generator",
						"intro": "自动生成模型的提示词",
						"link": "https://www.aipromptgenerator.net/zh",
						"logo": "AI_Prompt_Generator.svg",
						"sort": 63,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFABAB", // 浅红色背景
						"avatarName": "A", // platformName的第一个字
						"avatarColor": "#3E2723" // 深色对比
					},
					{
						"platformName": "DeepSeek提示库",
						"intro": "DeepSeek官方提供的提示词样例",
						"link": "https://api-docs.deepseek.com/zh-cn/prompt-library",
						"logo": "DeepSeek.png",
						"sort": 64,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFABAB", // 浅红色背景
						"avatarName": "P", // platformName的第一个字
						"avatarColor": "#3E2723" // 深色对比
					},
					{
						"platformName": "PromptPort",
						"intro": "提供文本、图像、视频的提示词样例",
						"link": "https://promptport.ai",
						"logo": "PromptPort.svg",
						"sort": 65,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFABAB", // 浅红色背景
						"avatarName": "P", // platformName的第一个字
						"avatarColor": "#3E2723" // 深色对比
					},
					{
						"platformName": "Way to AGI",
						"intro": "通往AGI社区创建的提示词样例合集",
						"link": "https://waytoagi.feishu.cn/wiki/QpbdwR9WOix3x9kEBcIcHzaKn0b?table=tblJmjjUu2j9PPvC&view=vewEM4m4KL",
						"logo": "Way_to_AGI.png",
						"sort": 66,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFABAB", // 浅红色背景
						"avatarName": "P", // platformName的第一个字
						"avatarColor": "#3E2723" // 深色对比
					},
			]
	},
	{
			"categoryName": "搜索引擎",
			"clientUserThirdPartyAccountResponses": [
					{
							"platformName": "菁菱谷AI",
							"intro": "人工智能产业政策推荐系统",
							"link": "https://www.jinglinggu.net/",
							"logo": "jinglinggu-icon.png",
							"sort": 62,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#B0BEC5", // 灰蓝色背景
							"avatarName": "菁", // platformName的第一个字
							"avatarColor": "#263238" // 深色对比
					},
					{
							"platformName": "秘塔AI搜索",
							"intro": "秘塔科技推出的AI3，无广告直达结果",
							"link": "https://metaso.cn/?s=huyaai.cn",
							"logo": "metaso-ai-search-icon.png",
							"sort": 63,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFCCBC", // 浅橙色背景
							"avatarName": "秘", // platformName的第一个字
							"avatarColor": "#BF360C" // 深色对比
					},
					{
							"platformName": "Dexa AI",
							"intro": "AI播客搜索工具",
							"link": "https://dexa.ai/?utm_source=huyaai.cn",
							"logo": "dexa-ai-icon.png",
							"sort": 64,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#C8E6C9", // 浅绿色背景
							"avatarName": "D", // platformName的第一个字
							"avatarColor": "#1B5E20" // 深色对比
					},
					// {
					// 		"platformName": "Devv",
					// 		"intro": "面向程序员的新一代AI3",
					// 		"link": "https://devv.ai/zh?ref=huyaai.cn",
					// 		"logo": "devv-ai-icon.png",
					// 		"sort": 65,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#FFABAB", // 浅红色背景
					// 		"avatarName": "D", // platformName的第一个字
					// 		"avatarColor": "#3E2723" // 深色对比
					// },
					{
							"platformName": "Exa AI",
							"intro": "针对 Web 数据的搜索及整理工具",
							"link": "https://websets.exa.ai/",
							"logo": "Exa-AI-logo.png",
							"sort": 66,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#B2DFDB", // 浅绿色背景
							"avatarName": "E", // platformName的第一个字
							"avatarColor": "#004D40" // 深色对比
					},
					{
							"platformName": "Globe Explorer",
							"intro": "以图片返回话题的结构化搜索结果",
							"link": "https://explorer.globe.engineer/?utm_source=huyaai.cn",
							"logo": "globe-explorer-icon.png",
							"sort": 67,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFE0B2", // 浅黄色背景
							"avatarName": "G", // platformName的第一个字
							"avatarColor": "#BF360C" // 深色对比
					},
					// {
					// 		"platformName": "夸克AI",
					// 		"intro": "集AI搜索、网盘、文档、创作等功能于一体的应用",
					// 		"link": "https://b.quark.cn/apps/qkhomepage_twofoufeb/routes/model?entry=other_xinyanpckk_cpa1&ch=other_xinyanpckk_cpa1&image=search&dp=",
					// 		"logo": "quark-logo.png",
					// 		"sort": 68,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#E1BEE7", // 浅紫色背景
					// 		"avatarName": "夸", // platformName的第一个字
					// 		"avatarColor": "#4A148C" // 深色对比
					// },
					{
							"platformName": "博查AI搜索",
							"intro": "基于多种大模型的在线搜索工具",
							"link": "https://bochaai.com/?ref=huyaai.cn",
							"logo": "bocha-ai-icon.png",
							"sort": 69,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFCCBC", // 浅橙色背景
							"avatarName": "博", // platformName的第一个字
							"avatarColor": "#BF360C" // 深色对比
					},
					{
							"platformName": "开搜AI",
							"intro": "搜索并返回网络资源的在线搜索工具",
							"link": "https://kaisouai.com/?from=huyaai.cn",
							"logo": "kaisouai-icon.png",
							"sort": 70,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#B2EBF2", // 浅蓝色背景
							"avatarName": "开", // platformName的第一个字
							"avatarColor": "#006064" // 深色对比
					},
					{
							"platformName": "AMiner",
							"intro": "智谱清言推出的论文检索与文献追踪工具",
							"link": "https://www.aminer.cn/?f=huyaai.cn",
							"logo": "aminer-logo.png",
							"sort": 71,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFABAB", // 浅红色背景
							"avatarName": "A", // platformName的第一个字
							"avatarColor": "#3E2723" // 深色对比
					},
					{
							"platformName": "心流AI助手",
							"intro": "阿里推出的在线信息检索与知识问答工具",
							"link": "https://iflow.cn/?utm_source=huyaai.cn",
							"logo": "iflow-icon.png",
							"sort": 72,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#E0F7FA", // 浅蓝色背景
							"avatarName": "心", // platformName的第一个字
							"avatarColor": "#006064" // 深色对比
					},
					// {
					// 		"platformName": "SearchGPT",
					// 		"intro": "OpenAI最新推出的AI搜索产品，内测开放",
					// 		"link": "https://cn.bing.com/search?q=SearchGPT&ensearch=1",
					// 		"logo": "SearchGPT-logo.png",
					// 		"sort": 73,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#FFCCBC", // 浅橙色背景
					// 		"avatarName": "S", // platformName的第一个字
					// 		"avatarColor": "#BF360C" // 深色对比
					// },
					{
							"platformName": "知乎直答",
							"intro": "知乎推出的基于知乎社区内容的知识问答工具",
							"link": "https://zhida.zhihu.com/?utm_source=huyaai.cn",
							"logo": "zhihu-zhida-icon.png",
							"sort": 74,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#E1BEE7", // 浅紫色背景
							"avatarName": "知", // platformName的第一个字
							"avatarColor": "#4A148C" // 深色对比
					},
					{
							"platformName": "Reddo",
							"intro": "全球产品信息AI搜索工具",
							"link": "https://www.reddo.cloud/search_home?utm_source=huyaai.cn",
							"logo": "Reddo-logo.png",
							"sort": 75,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFCCBC", // 浅橙色背景
							"avatarName": "R", // platformName的第一个字
							"avatarColor": "#BF360C" // 深色对比
					},
					{
							"platformName": "链企AI",
							"intro": "AI商业搜索和标讯服务平台",
							"link": "https://www.lianqiai.cn/?utm_source=huyaai.cn",
							"logo": "lianqiai-logo.png",
							"sort": 76,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#B2DFDB", // 浅绿色背景
							"avatarName": "链", // platformName的第一个字
							"avatarColor": "#004D40" // 深色对比
					},
					{
							"platformName": "XAnswer",
							"intro": "支持生成思维导图的免费AI搜索工具",
							"link": "https://www.xanswer.com/?utm_source=huyaai.cn",
							"logo": "XAnswer-logo.png",
							"sort": 77,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFCCBC", // 浅橙色背景
							"avatarName": "X", // platformName的第一个字
							"avatarColor": "#BF360C" // 深色对比
					},
					// {
					// 		"platformName": "Flowith",
					// 		"intro": "节点交互式AI搜索和对话工具",
					// 		"link": "https://flowith.io/invitation?code=L0D5I5",
					// 		"logo": "flowith-icon.png",
					// 		"sort": 78,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#E0F7FA", // 浅蓝色背景
					// 		"avatarName": "F", // platformName的第一个字
					// 		"avatarColor": "#006064" // 深色对比
					// },
					{
							"platformName": "天工AI搜索",
							"intro": "支持在线搜索、写作、对话、文档分析等的AI助手",
							"link": "https://search.tiangong.cn/?utm_source=huyaai.cn",
							"logo": "tiangong-ai-search-icon.png",
							"sort": 79,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFCCBC", // 浅橙色背景
							"avatarName": "天", // platformName的第一个字
							"avatarColor": "#BF360C" // 深色对比
					},
					// {
					// 		"platformName": "Genspark",
					// 		"intro": "基于智能体的AI3",
					// 		"link": "https://www.genspark.ai/?utm_source=huyaai.cn",
					// 		"logo": "genspark-icon.png",
					// 		"sort": 80,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#B2DFDB", // 浅绿色背景
					// 		"avatarName": "G", // platformName的第一个字
					// 		"avatarColor": "#004D40" // 深色对比
					// },
					{
							"platformName": "问问小宇宙",
							"intro": "小宇宙推出的AI播客内容搜索工具",
							"link": "https://ask.xiaoyuzhoufm.com/?utm_source=huyaai.cn",
							"logo": "xiaoyuzhou-website.png",
							"sort": 81,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#E1BEE7", // 浅紫色背景
							"avatarName": "问", // platformName的第一个字
							"avatarColor": "#4A148C" // 深色对比
					},
					// {
					// 		"platformName": "CuspAI",
					// 		"intro": "剑桥大学推出的材料学专业AI搜索工具",
					// 		"link": "https://www.cusp.ai/?utm_source=huyaai.cn",
					// 		"logo": "CuspAI-website.png",
					// 		"sort": 82,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#FFCCBC", // 浅橙色背景
					// 		"avatarName": "C", // platformName的第一个字
					// 		"avatarColor": "#BF360C" // 深色对比
					// },
					// {
					// 		"platformName": "Adot",
					// 		"intro": "一个由AI驱动的 Web3 3",
					// 		"link": "https://www.adot.tech/?utm_source=huyaai.cn",
					// 		"logo": "Adot-website02.png",
					// 		"sort": 83,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#B2DFDB", // 浅绿色背景
					// 		"avatarName": "A", // platformName的第一个字
					// 		"avatarColor": "#004D40" // 深色对比
					// },
					{
							"platformName": "AlphaSense",
							"intro": "金融市场的AI搜索工具",
							"link": "https://www.alpha-sense.com/?utm_source=huyaai.cn",
							"logo": "AlphaSense-logo.png",
							"sort": 84,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#E1BEE7", // 浅紫色背景
							"avatarName": "A", // platformName的第一个字
							"avatarColor": "#4A148C" // 深色对比
					},
					{
							"platformName": "Reportify",
							"intro": "投资研究问答及公开文件搜索工具",
							"link": "https://reportify.cc/?ref=huyaai.cn",
							"logo": "reportify-icon.png",
							"sort": 85,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFCCBC", // 浅橙色背景
							"avatarName": "R", // platformName的第一个字
							"avatarColor": "#BF360C" // 深色对比
					},
					{
							"platformName": "Phind",
							"intro": "擅长处理编程的搜索及问答工具",
							"link": "https://www.phind.com/?utm_source=huyaai.cn",
							"logo": "phind-icon.png",
							"sort": 86,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#B2DFDB", // 浅绿色背景
							"avatarName": "P", // platformName的第一个字
							"avatarColor": "#004D40" // 深色对比
					},
					{
							"platformName": "iAsk AI",
							"intro": "免费的智能问答工具",
							"link": "https://iask.ai/?utm_source=huyaai.cn",
							"logo": "iask-ai-icon.png",
							"sort": 87,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#E1BEE7", // 浅紫色背景
							"avatarName": "i", // platformName的第一个字
							"avatarColor": "#4A148C" // 深色对比
					},
					{
							"platformName": "Consensus",
							"intro": "用于科学研究的AI搜索工具",
							"link": "https://consensus.app/?utm_source=huyaai.cn",
							"logo": "consensus-icon.png",
							"sort": 88,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFCCBC", // 浅橙色背景
							"avatarName": "C", // platformName的第一个字
							"avatarColor": "#BF360C" // 深色对比
					},
					{
							"platformName": "Komo Search",
							"intro": "支持搜索、研究等的问答工具",
							"link": "https://komo.ai/?utm_source=huyaai.cn",
							"logo": "komo-search-icon.png",
							"sort": 89,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#B2DFDB", // 浅绿色背景
							"avatarName": "K", // platformName的第一个字
							"avatarColor": "#004D40" // 深色对比
					},
					// {
					// 		"platformName": "Searcholic",
					// 		"intro": "AI驱动的电子书和文档3",
					// 		"link": "https://searcholic.com/?utm_source=huyaai.cn",
					// 		"logo": "searcholic-icon.png",
					// 		"sort": 90,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#E1BEE7", // 浅紫色背景
					// 		"avatarName": "S", // platformName的第一个字
					// 		"avatarColor": "#4A148C" // 深色对比
					// },
					{
							"platformName": "Andi",
							"intro": "在线搜索与问答工具",
							"link": "https://andisearch.com/?utm_source=huyaai.cn",
							"logo": "andi-search-icon.png",
							"sort": 91,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFCCBC", // 浅橙色背景
							"avatarName": "A", // platformName的第一个字
							"avatarColor": "#BF360C" // 深色对比
					},
					// {
					// 		"platformName": "Songtell",
					// 		"intro": "AI驱动的音乐百科3",
					// 		"link": "https://www.songtell.com/?utm_source=huyaai.cn",
					// 		"logo": "songtell-icon.png",
					// 		"sort": 92,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#B2DFDB", // 浅绿色背景
					// 		"avatarName": "S", // platformName的第一个字
					// 		"avatarColor": "#004D40" // 深色对比
					// },
					// {
					// 		"platformName": "ThinkAny",
					// 		"intro": "新时代的AI3",
					// 		"link": "https://thinkany.ai/zh?utm_source=huyaai.cn",
					// 		"logo": "thinkany-icon.png",
					// 		"sort": 93,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#E1BEE7", // 浅紫色背景
					// 		"avatarName": "T", // platformName的第一个字
					// 		"avatarColor": "#4A148C" // 深色对比
					// },
					{
							"platformName": "Miku",
							"intro": "在线搜索、总结、可视化工具",
							"link": "https://www.hellomiku.com/?utm_source=huyaai.cn",
							"logo": "miku-icon.png",
							"sort": 94,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#B2DFDB", // 浅绿色背景
							"avatarName": "M", // platformName的第一个字
							"avatarColor": "#004D40" // 深色对比
					},{
						"platformName": "纳米AI",
						"intro": "提供多种AI模型及在线搜索的工具",
						"link": "https://bot.n.cn/",
						"logo": "namiAI.png",
						"sort": 95,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2DFDB", // 浅绿色背景
						"avatarName": "M", // platformName的第一个字
						"avatarColor": "#004D40" // 深色对比
				},{
					"platformName": "Hika AI",
					"intro": "AI知识搜索及个性化交互工具",
					"link": "https://hika.fyi/",
					"logo": "Hika_AI.jpg",
					"sort": 96,
					"instructions": "",
					"videoUrl": "",
					"username": "",
					"accounts": [],
					"backgroundColor": "#B2DFDB", // 浅绿色背景
					"avatarName": "M", // platformName的第一个字
					"avatarColor": "#004D40" // 深色对比
			},{
				"platformName": "Accio",
				"intro": "B2B领域的对话式搜索引擎",
				"link": "https://www.accio.com/",
				"logo": "Accio.png",
				"sort": 97,
				"instructions": "",
				"videoUrl": "",
				"username": "",
				"accounts": [],
				"backgroundColor": "#B2DFDB", // 浅绿色背景
				"avatarName": "M", // platformName的第一个字
				"avatarColor": "#004D40" // 深色对比
		}
			]
	},
	{
			"categoryName": "办公工具",
			"clientUserThirdPartyAccountResponses": [
					{
							"platformName": "AiPPT",
							"intro": "AI快速生成高质量PPT",
							"link": "https://www.aippt.cn/?seller=bscx",
							"logo": "aippt-cn-icon.png",
							"sort": 95,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#B0BEC5", // 灰蓝色背景
							"avatarName": "A", // platformName的第一个字
							"avatarColor": "#263238" // 深色对比
					},
					{
							"platformName": "美图AI PPT",
							"intro": "美图秀秀推出的免费在线AI生成PPT5",
							"link": "https://www.designkit.com/ppt/?channel=huyaai.cn",
							"logo": "meitu-ai-ppt.jpg",
							"sort": 96,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFAB91", // 浅橙色背景
							"avatarName": "美", // platformName的第一个字
							"avatarColor": "#BF360C" // 深色对比
					},
					{
							"platformName": "通义听悟",
							"intro": "阿里巴巴推出听悟一下，轻松学习",
							"link": "https://tingwu.aliyun.com/",
							"logo": "image.png",
							"sort": 97,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#C5E1A5", // 浅绿色背景
							"avatarName": "通", // platformName的第一个字
							"avatarColor": "#33691E" // 深色对比
					},
					{
							"platformName": "讯飞智文",
							"intro": "科大讯飞推出的免费AI PPT生成工具",
							"link": "https://zhiwen.xfyun.cn/?utm_source=huyaai.cn",
							"logo": "xunfei-zhiwen-icon.png",
							"sort": 98,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFCCBC", // 浅粉色背景
							"avatarName": "讯", // platformName的第一个字
							"avatarColor": "#BF360C" // 深色对比
					},
					{
							"platformName": "比格AI PPT",
							"intro": "高效的AI PPT生成工具",
							"link": "https://bigesj.com/ai-ppt/?hmmd=huyaai.cn",
							"logo": "bige-ai-ppt-icon.png",
							"sort": 99,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFE082", // 浅黄色背景
							"avatarName": "比", // platformName的第一个字
							"avatarColor": "#F57F17" // 深色对比
					},
					{
							"platformName": "iSlide AIPPT",
							"intro": "AI一键设计精美PPT，只需一句标题",
							"link": "https://www.islide.cc/?mtm_campaign=huyaai.cn",
							"logo": "islide-icon.png",
							"sort": 100,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#B2EBF2", // 浅蓝色背景
							"avatarName": "i", // platformName的第一个字
							"avatarColor": "#006064" // 深色对比
					},
					{
							"platformName": "Gamma App",
							"intro": "AI幻灯片演示生成工具",
							"link": "https://gamma.app/",
							"logo": "gamma-app-icon.png",
							"sort": 101,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#D1C4E9", // 浅紫色背景
							"avatarName": "G", // platformName的第一个字
							"avatarColor": "#4A148C" // 深色对比
					},
					{
							"platformName": "博思AIPPT",
							"intro": "在线AI生成PPT应用",
							"link": "https://pptgo.cn/?utm_source=huyaai.cn",
							"logo": "pptgo-icon.png",
							"sort": 102,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFCCBC", // 浅粉色背景
							"avatarName": "博", // platformName的第一个字
							"avatarColor": "#BF360C" // 深色对比
					},
					{
							"platformName": "笔灵AIPPT",
							"intro": "一键生成PPT和千字演讲稿",
							"link": "https://ibiling.cn/ppt-zone?from=huyaai.cn",
							"logo": "biling-aippt-logo.png",
							"sort": 103,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#C8E6C9", // 浅绿色背景
							"avatarName": "笔", // platformName的第一个字
							"avatarColor": "#1B5E20" // 深色对比
					},
					{
							"platformName": "万兴智演",
							"intro": "AI PPT和演示制作应用",
							"link": "https://zhiyan.wondershare.cn/?utm_source=huyaai.cn",
							"logo": "zhiyan-ai-icon.png",
							"sort": 104,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFAB91", // 浅橙色背景
							"avatarName": "万", // platformName的第一个字
							"avatarColor": "#BF360C" // 深色对比
					},
					{
							"platformName": "歌者AI",
							"intro": "彩漩PPT推出的AI PPT生成工具",
							"link": "https://gezhe.caixuan.cc/?ref=huyaai.cn",
							"logo": "gezhe-caixuan-icon.png",
							"sort": 105,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFCCBC", // 浅粉色背景
							"avatarName": "歌", // platformName的第一个字
							"avatarColor": "#BF360C" // 深色对比
					},
					// {
					// 		"platformName": "Decktopus AI",
					// 		"intro": "AI驱动的的在线演示文稿生成器",
					// 		"link": "https://www.decktopus.com/",
					// 		"logo": "decktopus-ai-icon.png",
					// 		"sort": 106,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#B2EBF2", // 浅蓝色背景
					// 		"avatarName": "D", // platformName的第一个字
					// 		"avatarColor": "#006064" // 深色对比
					// },
					{
							"platformName": "ChatPPT",
							"intro": "AI对话生成PPT，智能排版",
							"link": "https://www.chat-ppt.com/?channel=huyaai.cn",
							"logo": "chatppt-new-logo.png",
							"sort": 107,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#D1C4E9", // 浅紫色背景
							"avatarName": "C", // platformName的第一个字
							"avatarColor": "#4A148C" // 深色对比
					},
					{
							"platformName": "SlidesAI",
							"intro": "AI快速创建演示幻灯片",
							"link": "https://www.slidesai.io/",
							"logo": "slides-ai-icon.png",
							"sort": 108,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#C5E1A5", // 浅绿色背景
							"avatarName": "S", // platformName的第一个字
							"avatarColor": "#33691E" // 深色对比
					},
					{
							"platformName": "auxi",
							"intro": "功能强大的PowerPoint AI插件",
							"link": "https://www.auxi.ai/",
							"logo": "auxi-icon.png",
							"sort": 109,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFCCBC", // 浅粉色背景
							"avatarName": "a", // platformName的第一个字
							"avatarColor": "#BF360C" // 深色对比
					},
					{
							"platformName": "MindShow",
							"intro": "输入内容自动生成演示工具",
							"link": "https://www.mindshow.fun/?ref=huyaai.cn",
							"logo": "mindshow-icon.png",
							"sort": 110,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#B0BEC5", // 灰蓝色背景
							"avatarName": "M", // platformName的第一个字
							"avatarColor": "#263238" // 深色对比
					},
					{
							"platformName": "职得AIPPT",
							"intro": "免费高效的AIPPT生成工具",
							"link": "https://www.lgppt.cn/?utm_source=huyaai.cn",
							"logo": "lgppt-logo.png",
							"sort": 111,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFAB91", // 浅橙色背景
							"avatarName": "A", // platformName的第一个字
							"avatarColor": "#BF360C" // 深色对比
					},
					{
							"platformName": "ChatBA",
							"intro": "AI幻灯片生成工具",
							"link": "https://www.chatba.com/",
							"logo": "chatba-icon.png",
							"sort": 112,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#D1C4E9", // 浅紫色背景
							"avatarName": "C", // platformName的第一个字
							"avatarColor": "#4A148C" // 深色对比
					},
					{
							"platformName": "Tome",
							"intro": "AI创作叙事性幻灯片",
							"link": "https://tome.app/",
							"logo": "tome-app-icon.png",
							"sort": 113,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#B2DFDB", // 浅绿色背景
							"avatarName": "T", // platformName的第一个字
							"avatarColor": "#004D40" // 深色对比
					},
					{
							"platformName": "Powerpresent AI",
							"intro": "AI创建精美的演示稿",
							"link": "https://powerpresent.ai/",
							"logo": "powerpresent-ai-icon.png",
							"sort": 114,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFCCBC", // 浅粉色背景
							"avatarName": "P", // platformName的第一个字
							"avatarColor": "#BF360C" // 深色对比
					},
					// {
					// 		"platformName": "beautiful.ai",
					// 		"intro": "AI创建展示幻灯片",
					// 		"link": "https://www.beautiful.ai/",
					// 		"logo": "beautiful-ai-icon.png",
					// 		"sort": 115,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#C5E1A5", // 浅绿色背景
					// 		"avatarName": "美", // platformName的第一个字
					// 		"avatarColor": "#33691E" // 深色对比
					// },
					{
							"platformName": "轻竹办公",
							"intro": "在线智能生成和设计PPT",
							"link": "https://qzoffice.com?from=huyaai.cn",
							"logo": "qzoffice-icon.png",
							"sort": 116,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#B2DFDB", // 浅绿色背景
							"avatarName": "轻", // platformName的第一个字
							"avatarColor": "#004D40" // 深色对比
					},
					{
							"platformName": "Chronicle",
							"intro": "AI高颜值演示文稿创建",
							"link": "https://chroniclehq.com/",
							"logo": "chronicle-icon.png",
							"sort": 117,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#D1C4E9", // 浅紫色背景
							"avatarName": "C", // platformName的第一个字
							"avatarColor": "#4A148C" // 深色对比
					},
					{
							"platformName": "万知",
							"intro": "一站式AI文档阅读和PPT创作",
							"link": "https://www.wanzhi01.com/?ref=huyaai.cn",
							"logo": "wanzhi01-icon.png",
							"sort": 118,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#FFAB91", // 浅橙色背景
							"avatarName": "万", // platformName的第一个字
							"avatarColor": "#BF360C" // 深色对比
					},
					// {
					// 		"platformName": "Presentations.AI",
					// 		"intro": "演示文档版的ChatGPT",
					// 		"link": "https://www.presentations.ai/",
					// 		"logo": "presentations-ai-icon.png",
					// 		"sort": 119,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#C5E1A5", // 浅绿色背景
					// 		"avatarName": "P", // platformName的第一个字
					// 		"avatarColor": "#33691E" // 深色对比
					// },
					{
							"platformName": "办公小浣熊",
							"intro": "数据分析，一招搞定",
							"link": "https://xiaohuanxiong.com/",
							"logo": "微信图片_20241022210058.png",
							"sort": 120,
							"instructions": "",
							"videoUrl": "",
							"username": "",
							"accounts": [],
							"backgroundColor": "#B0BEC5", // 灰蓝色背景
							"avatarName": "办", // platformName的第一个字
							"avatarColor": "#263238" // 深色对比
					},
					// {
					// 		"platformName": "知网AI智能备课",
					// 		"intro": "教师的智能备课助手，能自动生成教学方案",
					// 		"link": "https://aibk.cnki.net/",
					// 		"logo": "微信图片_20240923213342.png",
					// 		"sort": 121,
					// 		"instructions": "",
					// 		"videoUrl": "",
					// 		"username": "",
					// 		"accounts": [],
					// 		"backgroundColor": "#FFCCBC", // 浅粉色背景
					// 		"avatarName": "知", // platformName的第一个字
					// 		"avatarColor": "#BF360C" // 深色对比
					// }
			]
	},
{
		"categoryName": "写作工具",
		"clientUserThirdPartyAccountResponses": [
				{
						"platformName": "火山写作",
						"intro": "AI写作助手",
						"link": "https://writingo.net/document?utm_source=huyaai.cn",
						"logo": "huoshan-writing-icon.png",
						"sort": 122,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "火", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				// {
				// 		"platformName": "讯飞公文写作助手",
				// 		"intro": "国产大模型AI公文5",
				// 		"link": "https://gw.iflydocs.com/?from=huyaai.cn",
				// 		"logo": "iflydocs-gw-icon.png",
				// 		"sort": 123,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#C5E1A5", // 浅绿色背景
				// 		"avatarName": "讯", // platformName的第一个字
				// 		"avatarColor": "#33691E" // 深色对比
				// },
				{
						"platformName": "讯飞绘文",
						"intro": "免费AI写作助理",
						"link": "https://turbodesk.xfyun.cn/?channelid=gj39",
						"logo": "turbodesk-icon.png",
						"sort": 124,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅粉色背景
						"avatarName": "绘", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "笔灵AI写作",
						"intro": "面向专业写作领域的AI",
						"link": "https://ibiling.cn/?from=huyaai.cn",
						"logo": "ibiling-icon.png",
						"sort": 125,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB91", // 浅橙色背景
						"avatarName": "笔", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "Paperpal",
						"intro": "面向科研人员的AI",
						"link": "https://www.editage.cn/paperpal?utm_source=huyaai.cn&utm_medium=Banner&utm_campaign=Banner",
						"logo": "paperpal-icon.png",
						"sort": 126,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2DFDB", // 浅青色背景
						"avatarName": "P", // platformName的第一个字
						"avatarColor": "#004D40" // 深色对比
				},
				{
						"platformName": "秘塔写作猫",
						"intro": "AI写作，文章自成",
						"link": "https://xiezuocat.com/?s=huyaai.cn",
						"logo": "xiezuocat-ai-icon.png",
						"sort": 127,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅粉色背景
						"avatarName": "秘", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "讯飞写作",
						"intro": "科大讯飞推出的AI智能写作助手",
						"link": "https://huixie.iflyrec.com/list?from=huyaai.cn",
						"logo": "huixie-iflyrec-logo1.png",
						"sort": 128,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C5E1A5", // 浅绿色背景
						"avatarName": "讯", // platformName的第一个字
						"avatarColor": "#33691E" // 深色对比
				},
				{
						"platformName": "新华妙笔",
						"intro": "新华社推出的AI公文写作平台",
						"link": "https://miaobi.xinhuaskl.com/?channel=shuzhi",
						"logo": "xinhua-miaobi-icon.png",
						"sort": 129,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB91", // 浅橙色背景
						"avatarName": "新", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "光速写作",
						"intro": "AI写作、PPT生成工具",
						"link": "https://www.guangsuxie.com/static/college-write-web/home?from=huyaai.cn ",
						"logo": "guangsuxie-icon.png",
						"sort": 130,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2DFDB", // 浅青色背景
						"avatarName": "光", // platformName的第一个字
						"avatarColor": "#004D40" // 深色对比
				},
				{
						"platformName": "橙篇",
						"intro": "AI长文理解和内容创作工具",
						"link": "https://cp.baidu.com/?utm_source=huyaai.cn",
						"logo": "chengpian-icon.png",
						"sort": 131,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅粉色背景
						"avatarName": "橙", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "Jasper",
						"intro": "AI文字内容创作工具",
						"link": "https://cn.bing.com/search?q=Jasper&ensearch=1",
						"logo": "jasper-ai-icon.png",
						"sort": 132,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "J", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				{
						"platformName": "库宝AI工作助手",
						"intro": "千库网推出的多功能AI创作工具",
						"link": "https://588tool.com/?hd=1240",
						"logo": "588tool-logo.png",
						"sort": 133,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C5E1A5", // 浅绿色背景
						"avatarName": "库", // platformName的第一个字
						"avatarColor": "#33691E" // 深色对比
				},
				{
						"platformName": "66AI论文",
						"intro": "高质量、低查重、低AIGC率的AI论文5",
						"link": "https://www.66paper.cn/AI_A2E1C09",
						"logo": "66paper-logo.png",
						"sort": 134,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB91", // 浅橙色背景
						"avatarName": "6", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "千笔AI论文",
						"intro": "AI论文生成器，一键生成3万字论文",
						"link": "https://www.aipaperpass.com?pic=g5DP",
						"logo": "aipaperpass-icon.png",
						"sort": 135,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2DFDB", // 浅青色背景
						"avatarName": "千", // platformName的第一个字
						"avatarColor": "#004D40" // 深色对比
				},
				// {
				// 		"platformName": "Copy.ai",
				// 		"intro": "人工智能营销文案和内容创作工具",
				// 		"link": "https://cn.bing.com/search?q=Copy.ai&ensearch=1",
				// 		"logo": "copy-ai-icon.png",
				// 		"sort": 136,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFCCBC", // 浅粉色背景
				// 		"avatarName": "C", // platformName的第一个字
				// 		"avatarColor": "#BF360C" // 深色对比
				// },
				// {
				// 		"platformName": "Writesonic",
				// 		"intro": "AI写作，文案，释义工具",
				// 		"link": "https://cn.bing.com/search?q=Writesonic&ensearch=1",
				// 		"logo": "writesonic-icon.png",
				// 		"sort": 137,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#B0BEC5", // 灰蓝色背景
				// 		"avatarName": "W", // platformName的第一个字
				// 		"avatarColor": "#263238" // 深色对比
				// },
				// {
				// 		"platformName": "Rytr",
				// 		"intro": "AI内容生成和写作助手",
				// 		"link": "https://cn.bing.com/search?q=Rytr&ensearch=1",
				// 		"logo": "rytr-me-icon.png",
				// 		"sort": 138,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#C5E1A5", // 浅绿色背景
				// 		"avatarName": "R", // platformName的第一个字
				// 		"avatarColor": "#33691E" // 深色对比
				// },
				{
						"platformName": "晓语台",
						"intro": "智能AI5，内置500+创作模板",
						"link": "https://www.xiaoyutai.com/?share_code=XYT90931478",
						"logo": "xiaoyutai-icon.png",
						"sort": 139,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB91", // 浅橙色背景
						"avatarName": "晓", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "万能小in",
						"intro": "AI写作助手，3分钟5万字论文初稿一键生成",
						"link": "https://xiaoin.cn/home/index?sharerUserId=1815301629231030274",
						"logo": "xiaoin-logo.png",
						"sort": 140,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2DFDB", // 浅青色背景
						"avatarName": "万", // platformName的第一个字
						"avatarColor": "#004D40" // 深色对比
				},
				// {
				// 		"platformName": "Notion AI",
				// 		"intro": "Notion推出的AI内容创作助手",
				// 		"link": "https://cn.bing.com/search?q=Notion AI&ensearch=1",
				// 		"logo": "notion-ai-icon.png",
				// 		"sort": 141,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFCCBC", // 浅粉色背景
				// 		"avatarName": "N", // platformName的第一个字
				// 		"avatarColor": "#BF360C" // 深色对比
				// },
				{
						"platformName": "墨狐AI",
						"intro": "短篇小说AI写作助手，专为网文小说作者设计",
						"link": "https://inkfox-ai.com/?utm_source=huyaai.cn",
						"logo": "mohuai-logo-1.png",
						"sort": 142,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "墨", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				{
						"platformName": "Grammarly",
						"intro": "AI英语语法和拼写检查写作助手",
						"link": "https://www.grammarly.com/",
						"logo": "grammarly-icon.png",
						"sort": 143,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C5E1A5", // 浅绿色背景
						"avatarName": "G", // platformName的第一个字
						"avatarColor": "#33691E" // 深色对比
				},
				{
						"platformName": "QuillBot",
						"intro": "AI英/德语写作润色和改进工具",
						"link": "https://try.quillbot.com/6eqrqpoysmlh",
						"logo": "quillbot-icon.png",
						"sort": 144,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB91", // 浅橙色背景
						"avatarName": "Q", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "AI新媒体文章",
						"intro": "夸克推出的AI写作工具",
						"link": "https://vt.quark.cn/blm/creator-773/index?utm_source=huyaai.cn",
						"logo": "quark-creator-logo.png",
						"sort": 145,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2DFDB", // 浅青色背景
						"avatarName": "A", // platformName的第一个字
						"avatarColor": "#004D40" // 深色对比
				},
				{
						"platformName": "FlowUs AI",
						"intro": "在线文档平台息流推出的AI创作助手，类似于Notion AI",
						"link": "https://flowus.cn/ai?ref=huyaai.cn",
						"logo": "flowus-icon.png",
						"sort": 146,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅粉色背景
						"avatarName": "F", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "MidReal",
						"intro": "AI互动式小说文本生成工具",
						"link": "https://midreal.ai/?utm_source=huyaai.cn",
						"logo": "MidReal-logo.png",
						"sort": 147,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "M", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				{
						"platformName": "DeepL Write",
						"intro": "DeepL推出的AI驱动的写作助手",
						"link": "https://www.deepl.com/write",
						"logo": "deepl-write-icon.png",
						"sort": 148,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C5E1A5", // 浅绿色背景
						"avatarName": "D", // platformName的第一个字
						"avatarColor": "#33691E" // 深色对比
				},
				// {
				// 		"platformName": "Jenni",
				// 		"intro": "AI研究文章和博客写作辅助工具",
				// 		"link": "https://cn.bing.com/search?q=Jenni&ensearch=1",
				// 		"logo": "jenni-ai-icon.png",
				// 		"sort": 149,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFAB91", // 浅橙色背景
				// 		"avatarName": "J", // platformName的第一个字
				// 		"avatarColor": "#BF360C" // 深色对比
				// },
				// {
				// 		"platformName": "奇妙文",
				// 		"intro": "出门问问推出的AI写作助理",
				// 		"link": "https://wen.mobvoi.com/?ref=huyaai.cn",
				// 		"logo": "wen-mobvoi-icon.png",
				// 		"sort": 150,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#B2DFDB", // 浅青色背景
				// 		"avatarName": "奇", // platformName的第一个字
				// 		"avatarColor": "#004D40" // 深色对比
				// },
				{
						"platformName": "有道写作",
						"intro": "网易有道出品的智能英文写作修改和润色工具",
						"link": "https://write.youdao.com/#/homepage",
						"logo": "write-youdao-icon.png",
						"sort": 151,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅粉色背景
						"avatarName": "有", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "写作蛙",
						"intro": "Your Intelligent Writing Partner, Choose Your AI, Find Your Voice",
						"link": "https://littlefrog.ai/?utm_source=huyaai.cn",
						"logo": "littlefrog-ai-icon.png",
						"sort": 152,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "写", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				{
						"platformName": "WriteWise",
						"intro": "喜马拉雅推出的免费网文和小说AI",
						"link": "https://www.ximalaya.com/gatekeeper/write-wise-web?ref=huyaai.cn",
						"logo": "writewise-icon.png",
						"sort": 153,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C5E1A5", // 浅绿色背景
						"avatarName": "写", // platformName的第一个字
						"avatarColor": "#33691E" // 深色对比
				},
				{
						"platformName": "百度作家平台",
						"intro": "百度免费AI小说",
						"link": "https://zuojia.baidu.com/",
						"logo": "baidu-zuojia-icon-1.png",
						"sort": 154,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB91", // 浅橙色背景
						"avatarName": "百", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "爱创作",
						"intro": "ZAKER新闻推出的AI",
						"link": "https://ai.zaker.cn/",
						"logo": "ai-zaker-icon.png",
						"sort": 155,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2DFDB", // 浅青色背景
						"avatarName": "爱", // platformName的第一个字
						"avatarColor": "#004D40" // 深色对比
				},
				{
						"platformName": "Verse",
						"intro": "印象笔记旗下团队推出的AI写作和文档工具",
						"link": "https://verse.app.yinxiang.com/product/?utm_source=huyaai.cn",
						"logo": "verse-icon.png",
						"sort": 156,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅粉色背景
						"avatarName": "V", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "魔音工坊",
						"intro": "出门问问旗下推出的AI智能",
						"link": "https://x.moyin.com/?ref=huyaai.cn",
						"logo": "x-moyin-icon.png",
						"sort": 157,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "魔", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				{
						"platformName": "蛙蛙写作",
						"intro": "AI小说和内容创作工具",
						"link": "https://www.wawawriter.com/?ref=huyaai.cn",
						"logo": "wawawriter-icon.png",
						"sort": 158,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C5E1A5", // 浅绿色背景
						"avatarName": "蛙", // platformName的第一个字
						"avatarColor": "#33691E" // 深色对比
				},
				{
						"platformName": "深言达意",
						"intro": "免费的词句查询智能写作辅助工具，输入模糊描述即可查找词句",
						"link": "https://www.shenyandayi.com/?ref=huyaai.cn",
						"logo": "shenyandayi-icon.png",
						"sort": 159,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB91", // 浅橙色背景
						"avatarName": "深", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "灵构AI笔记",
						"intro": "在线安全的灵感收集、思路整理AI笔记工具",
						"link": "https://88lingo.com/ai?utm_id=577",
						"logo": "88lingo-icon.png",
						"sort": 160,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2DFDB", // 浅青色背景
						"avatarName": "灵", // platformName的第一个字
						"avatarColor": "#004D40" // 深色对比
				},
				// {
				// 		"platformName": "Moonbeam",
				// 		"intro": "长文章AI内容创作助手",
				// 		"link": "https://cn.bing.com/search?q=Moonbeam&ensearch=1",
				// 		"logo": "moonbeam-icon.png",
				// 		"sort": 161,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFCCBC", // 浅粉色背景
				// 		"avatarName": "月", // platformName的第一个字
				// 		"avatarColor": "#BF360C" // 深色对比
				// },
				// {
				// 		"platformName": "Cohesive",
				// 		"intro": "人工智能文案内容创作和编辑工具",
				// 		"link": "https://cn.bing.com/search?q=Cohesive&ensearch=1",
				// 		"logo": "cohesive-icon.png",
				// 		"sort": 162,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#B0BEC5", // 灰蓝色背景
				// 		"avatarName": "C", // platformName的第一个字
				// 		"avatarColor": "#263238" // 深色对比
				// },
				{
						"platformName": "彩云小梦",
						"intro": "彩云科技推出的智能AI故事创作助手",
						"link": "https://if.caiyunai.com/",
						"logo": "if-caiyunai-icon.png",
						"sort": 163,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C5E1A5", // 浅绿色背景
						"avatarName": "彩", // platformName的第一个字
						"avatarColor": "#33691E" // 深色对比
				},
				{
						"platformName": "创客贴AI",
						"intro": "AI辅助的智能在线作图工具",
						"link": "https://www.chuangkit.com/inviteUser?code=6V1EDHBI",
						"logo": "chuangkit-aiart-icon.png",
						"sort": 164,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB91", // 浅橙色背景
						"avatarName": "创", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "稿定AI",
						"intro": "一站式AI创作和设计平台",
						"link": "https://www.gaoding.com/utms/70c9b2c822cd42de861fda9367640c0c",
						"logo": "gaoding-design-icon.png",
						"sort": 165,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2DFDB", // 浅青色背景
						"avatarName": "稿", // platformName的第一个字
						"avatarColor": "#004D40" // 深色对比
				},
				{
						"platformName": "美间AI",
						"intro": "免费AI助手，智能海报、提案和商品图生成",
						"link": "https://www.meijian.com/ai?from=mj_navigation?utm_source=huyaai.cn",
						"logo": "meijian-icon.png",
						"sort": 166,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅粉色背景
						"avatarName": "美", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "Figma AI",
						"intro": "Figma AI is a collection of features designed to help you work more efficiently and creatively.",
						"link": "https://www.figma.com/ai/?utm_source=huyaai.cn",
						"logo": "figma-icon.png",
						"sort": 167,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "F", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				// {
				// 		"platformName": "Microsoft Designer",
				// 		"intro": "微软推出的在线设计海报和宣传图工具",
				// 		"link": "https://designer.microsoft.com/",
				// 		"logo": "microsoft-designer-icon.png",
				// 		"sort": 168,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#C5E1A5", // 浅绿色背景
				// 		"avatarName": "M", // platformName的第一个字
				// 		"avatarColor": "#33691E" // 深色对比
				// },
				{
						"platformName": "美图设计室",
						"intro": "AI图像创作和设计平台",
						"link": "https://www.designkit.com/?channel=10026",
						"logo": "meitu-ai-ppt.jpg",
						"sort": 169,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB91", // 浅橙色背景
						"avatarName": "美", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "魔力工作室",
						"intro": "Canva可画推出的一站式AI创作套件",
						"link": "https://www.canva.cn/magic/?utm_source=huyaai.cn",
						"logo": "canva-icon.png",
						"sort": 170,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2DFDB", // 浅青色背景
						"avatarName": "魔", // platformName的第一个字
						"avatarColor": "#004D40" // 深色对比
				},
				{
						"platformName": "智绘设计",
						"intro": "腾讯推出的智能设计平台，让内容更精彩",
						"link": "https://taishan.qq.com/brand/?ref=huyaai.cn",
						"logo": "taishan-qq-icon.png",
						"sort": 171,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅粉色背景
						"avatarName": "智", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "MasterGo AI",
						"intro": "MasterGo推出的智能UI设计助手",
						"link": "https://mastergo.com/upcoming-ai/apply?utm_source=huyaai.cn",
						"logo": "mastergo-ai-icon.png",
						"sort": 172,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "M", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				{
						"platformName": "Looka",
						"intro": "AI在线设计和生成logo",
						"link": "https://looka.com/",
						"logo": "looka-icon.png",
						"sort": 173,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C5E1A5", // 浅绿色背景
						"avatarName": "L", // platformName的第一个字
						"avatarColor": "#33691E" // 深色对比
				},
				{
						"platformName": "Recraft AI",
						"intro": "免费无限AI画板，生成高质量矢量艺术画、图标、3D图片和插画",
						"link": "https://www.recraft.ai/?ref=huyaai.cn",
						"logo": "recraft-ai-icon.png",
						"sort": 174,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB91", // 浅橙色背景
						"avatarName": "R", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "即时AI",
						"intro": "即时设计推出的由文本描述生成可编辑的原型设计稿",
						"link": "https://jsai.cc/ai/create?source=huyaai.cn",
						"logo": "js-design-icon.png",
						"sort": 175,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2DFDB", // 浅青色背景
						"avatarName": "即", // platformName的第一个字
						"avatarColor": "#004D40" // 深色对比
				},
				{
						"platformName": "Pimento",
						"intro": "人工智能驱动的设计创意和视觉参考平台",
						"link": "https://www.pimento.design/?ref_id=TU7BJC0X4",
						"logo": "pimento-design-icon.png",
						"sort": 176,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅粉色背景
						"avatarName": "P", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				// {
				// 		"platformName": "Logo Diffusion",
				// 		"intro": "AI驱动的Logo和标志生成工具",
				// 		"link": "https://logodiffusion.com/?ref=huyaai.cn",
				// 		"logo": "logo-diffusion-icon.png",
				// 		"sort": 177,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#B0BEC5", // 灰蓝色背景
				// 		"avatarName": "L", // platformName的第一个字
				// 		"avatarColor": "#263238" // 深色对比
				// },
				{
						"platformName": "Realibox AI",
						"intro": "AI免费将草图/模型生成3D渲染图",
						"link": "https://www.realibox.com/product/ai?utm_source=huyaai.cn",
						"logo": "realibox-icon.png",
						"sort": 178,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C5E1A5", // 浅绿色背景
						"avatarName": "R", // platformName的第一个字
						"avatarColor": "#33691E" // 深色对比
				},
				{
						"platformName": "Vectorizer.AI",
						"intro": "AI一键将位图转换为矢量图片",
						"link": "https://vectorizer.ai/?utm_source=huyaai.cn",
						"logo": "vectorizer-ai-icon.png",
						"sort": 179,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB91", // 浅橙色背景
						"avatarName": "V", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "Collov AI",
						"intro": "AI室内家居设计生成平台",
						"link": "https://collov.cn/?ref=huyaai.cn",
						"logo": "collov-ai-icon.png",
						"sort": 180,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2DFDB", // 浅青色背景
						"avatarName": "C", // platformName的第一个字
						"avatarColor": "#004D40" // 深色对比
				},
				{
						"platformName": "包图网AI素材库",
						"intro": "包图网提供的特色图库服务",
						"link": "https://ibaotu.com/tupian/shuziyishu.html?spm==huyaai.cn",
						"logo": "baotu-logo.png",
						"sort": 181,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅粉色背景
						"avatarName": "包", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "Creatie",
						"intro": "AI驱动的UI和UX设计工具",
						"link": "https://creatie.ai/?ref=huyaai.cn",
						"logo": "creatie-icon.png",
						"sort": 182,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "C", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				{
						"platformName": "Kittl",
						"intro": "AI驱动的平面图形设计工具",
						"link": "https://www.kittl.com/?ref=huyaai.cn",
						"logo": "kittl-icon.png",
						"sort": 183,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C5E1A5", // 浅绿色背景
						"avatarName": "K", // platformName的第一个字
						"avatarColor": "#33691E" // 深色对比
				},
				// {
				// 		"platformName": "Stylar",
				// 		"intro": "一站式AI图像编辑和5",
				// 		"link": "https://www.stylar.ai/?via=huyaai.cn",
				// 		"logo": "stylar-ai-icon.png",
				// 		"sort": 184,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFAB91", // 浅橙色背景
				// 		"avatarName": "S", // platformName的第一个字
				// 		"avatarColor": "#BF360C" // 深色对比
				// },
				// {
				// 		"platformName": "Krea AI",
				// 		"intro": "AI创意设计平台，实时AI图像生成和编辑",
				// 		"link": "https://www.krea.ai/?ref=huyaai.cn",
				// 		"logo": "krea-ai-icon.png",
				// 		"sort": 185,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#B2DFDB", // 浅青色背景
				// 		"avatarName": "K", // platformName的第一个字
				// 		"avatarColor": "#004D40" // 深色对比
				// },
				{
						"platformName": "135 AI排版",
						"intro": "公众号AI图文排版和智能文案生成工具",
						"link": "https://www.135editor.com/ai_editor/?track_id=34&hmmd=huyaai.cn",
						"logo": "135-ai-editor-icon.png",
						"sort": 186,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅粉色背景
						"avatarName": "1", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "墨刀AI",
						"intro": "墨刀推出的AI产品原型设计助手",
						"link": "https://modao.cc/feature/ai.html?utm_source=huyaai.cn",
						"logo": "modao-icon.png",
						"sort": 187,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "墨", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				// {
				// 		"platformName": "FigJam AI",
				// 		"intro": "Figma推出的AI白板协作5",
				// 		"link": "https://www.figma.com/figjam/ai/",
				// 		"logo": "figma-icon.png",
				// 		"sort": 188,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#C5E1A5", // 浅绿色背景
				// 		"avatarName": "F", // platformName的第一个字
				// 		"avatarColor": "#33691E" // 深色对比
				// },
				// {
				// 		"platformName": "鹿班",
				// 		"intro": "阿里推出的智能设计商品图和海报的平台",
				// 		"link": "https://luban.aliyun.com/?ref=huyaai.cn",
				// 		"logo": "luban-icon.png",
				// 		"sort": 189,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFAB91", // 浅橙色背景
				// 		"avatarName": "鹿", // platformName的第一个字
				// 		"avatarColor": "#BF360C" // 深色对比
				// },
				{
						"platformName": "Motiff 妙多",
						"intro": "AI界面设计工具",
						"link": "https://motiff.com/?utm_source=huyaai.cn",
						"logo": "motiff-icon.png",
						"sort": 190,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2DFDB", // 浅青色背景
						"avatarName": "M", // platformName的第一个字
						"avatarColor": "#004D40" // 深色对比
				},
				{
						"platformName": "Canva可画",
						"intro": "轻松创建并分享专业设计",
						"link": "https://www.canva.com/magic-design/",
						"logo": "canva-icon.png",
						"sort": 191,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅粉色背景
						"avatarName": "魔", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "比格设计",
						"intro": "文生图、智能消除等AI合集。",
						"link": "https://bigesj.com/?hmmd=huyaai.cn&hmsr=bigeai",
						"logo": "ai_agent_header.png",
						"sort": 192,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "比", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				{
						"platformName": "VoxCraft",
						"intro": "AI生成3D模型的工具",
						"link": "https://voxcraft.ai/?utm_source=huyaai.cn",
						"logo": "voxcraft-icon.png",
						"sort": 193,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C5E1A5", // 浅绿色背景
						"avatarName": "V", // platformName的第一个字
						"avatarColor": "#33691E" // 深色对比
				},
				// {
				// 		"platformName": "Pictographic",
				// 		"intro": "AI插图资源库和生成平台",
				// 		"link": "https://pictographic.io/?utm_source=huyaai.cn",
				// 		"logo": "pictographic-icon.png",
				// 		"sort": 194,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFAB91", // 浅橙色背景
				// 		"avatarName": "P", // platformName的第一个字
				// 		"avatarColor": "#BF360C" // 深色对比
				// },
				// {
				// 		"platformName": "Fable Prism",
				// 		"intro": "AI动效设计和动画效果制作工具",
				// 		"link": "https://www.fable.app/prism?ref=huyaai.cn",
				// 		"logo": "fable-icon.png",
				// 		"sort": 195,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#B2DFDB", // 浅青色背景
				// 		"avatarName": "F", // platformName的第一个字
				// 		"avatarColor": "#004D40" // 深色对比
				// },
				{
						"platformName": "Wegic",
						"intro": "AI网页设计和建站开发工具",
						"link": "https://wegic.ai/?utm_source=huyaai.cn",
						"logo": "wegic-icon.png",
						"sort": 196,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅粉色背景
						"avatarName": "W", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "Ilus AI",
						"intro": "AI插画插图生成工具",
						"link": "https://ilus.ai/?utm_source=huyaai.cn",
						"logo": "ilus-ai-icon.png",
						"sort": 197,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "I", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				// {
				// 		"platformName": "LogoliveryAI",
				// 		"intro": "免费的AI Logo生成器，提供SVG矢量格式",
				// 		"link": "https://logolivery.ai/?utm_source=huyaai.cn",
				// 		"logo": "logoliveryai-icon.png",
				// 		"sort": 198,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#C5E1A5", // 浅绿色背景
				// 		"avatarName": "L", // platformName的第一个字
				// 		"avatarColor": "#33691E" // 深色对比
				// },
				// {
				// 		"platformName": "模袋云AI",
				// 		"intro": "建筑AI创作平台，专注于大型建筑、小型住宅、室内设计、景观的出图和AI模型训练",
				// 		"link": "https://www.modaiyun.com/mdy/ai?utm_source=huyaai.cn",
				// 		"logo": "modaiyun-ai-icon.png",
				// 		"sort": 199,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFAB91", // 浅橙色背景
				// 		"avatarName": "模", // platformName的第一个字
				// 		"avatarColor": "#BF360C" // 深色对比
				// },
				{
						"platformName": "酷家乐AI",
						"intro": "功能强大的AI家居设计软件",
						"link": "https://www.kujiale.cn/activities/AI-kujiale?ref=huyaai.cn",
						"logo": "kujiale-icon.png",
						"sort": 200,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2DFDB", // 浅青色背景
						"avatarName": "酷", // platformName的第一个字
						"avatarColor": "#004D40" // 深色对比
				},
				{
						"platformName": "Pixso AI",
						"intro": "Pixso的内置AI助手，支持AI文生图、AI对话、AI设计等",
						"link": "https://pixso.cn/?utm_source=huyaai.cn",
						"logo": "pixso-ai-icon.jpg",
						"sort": 201,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅粉色背景
						"avatarName": "P", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "Framer AI",
						"intro": "Framer推出的AI网站自动设计、生成和上线",
						"link": "https://www.framer.com/ai?utm_source=huyaai.cn",
						"logo": "framer-icon.png",
						"sort": 202,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "F", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				{
						"platformName": "Vizcom",
						"intro": "AI渲染转化手绘图为产品设计图",
						"link": "https://www.vizcom.ai/",
						"logo": "vizcom-ai-icon.png",
						"sort": 203,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C5E1A5", // 浅绿色背景
						"avatarName": "V", // platformName的第一个字
						"avatarColor": "#33691E" // 深色对比
				},
				{
						"platformName": "Dora AI",
						"intro": "AI在线生成精美3D动画的网站",
						"link": "https://www.dora.run/ai?ref=huyaai.cn",
						"logo": "dora-ai-icon.png",
						"sort": 204,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB91", // 浅橙色背景
						"avatarName": "多", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "Designs.ai",
						"intro": "使用生成型 AI 创建图像、视频等。",
						"link": "https://designs.ai/",
						"logo": "designs-ai-icon.png",
						"sort": 205,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2DFDB", // 浅青色背景
						"avatarName": "D", // platformName的第一个字
						"avatarColor": "#004D40" // 深色对比
				}
		]
},
{
		"categoryName": "设计工具",
		"clientUserThirdPartyAccountResponses": [
				{
						"platformName": "通义万相",
						"intro": "阿里最新推出的AI绘画创作模型",
						"link": "https://wanxiang.aliyun.com/",
						"logo": "tongyi-aliyun-icon.png",
						"sort": 206,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#7D9B9B", // 深青色背景
						"avatarName": "通", // platformName的第一个字
						"avatarColor": "#FFFFFF" // 白色对比
				},
				{
						"platformName": "奇域AI",
						"intro": "中式审美国风AI绘画创作平台",
						"link": "https://www.qiyuai.net",
						"logo": "qiyu-ai-icon.png",
						"sort": 207,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#A8B400", // 黄绿色背景
						"avatarName": "奇", // platformName的第一个字
						"avatarColor": "#2E2E2E" // 深灰色对比
				},
				{
						"platformName": "即梦Dreamina",
						"intro": "抖音旗下推出的AI图片创作工具",
						"link": "https://www.capcut.cn/ai-tool/?ref=huyaai.cn",
						"logo": "dreamina-icon.png",
						"sort": 208,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "即", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				{
						"platformName": "吐司AI",
						"intro": "AI绘画模型社区和在线生图平台",
						"link": "https://tusiart.com/?utm_source=huyaai.cn&source_id=huyaai.cn",
						"logo": "tusiart-logo.png",
						"sort": 209,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB91", // 浅橙色背景
						"avatarName": "吐", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "稿定AI",
						"intro": "一站式AI5集，免费AI绘图、图片转AI绘画、AI抠图消除",
						"link": "https://www.gaoding.com/utms/68f2b6d26cdb4048adf21904798c7229 ",
						"logo": "gaoding-design-icon.png",
						"sort": 210,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C5E1A5", // 浅绿色背景
						"avatarName": "稿", // platformName的第一个字
						"avatarColor": "#33691E" // 深色对比
				},
				{
						"platformName": "秒画",
						"intro": "商汤科技推出的免费AI作画和图片生成平台",
						"link": "https://miaohua.sensetime.com/?utm_source=huyaai.cn",
						"logo": "miaohua-icon.png",
						"sort": 211,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2DFDB", // 浅青色背景
						"avatarName": "秒", // platformName的第一个字
						"avatarColor": "#004D40" // 深色对比
				},
				{
						"platformName": "Upscayl",
						"intro": "免费开源的AI图片无损放大工具",
						"link": "https://www.upscayl.org/",
						"logo": "upscayl-icon.png",
						"sort": 212,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅桃色背景
						"avatarName": "U", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "触手AI绘画",
						"intro": "免费专业的AI绘画/模型/分享平台",
						"link": "https://acgnai.art/?utm_source=huyaai.cn",
						"logo": "douchu-ai-icon.png",
						"sort": 213,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D1C4E9", // 浅紫色背景
						"avatarName": "触", // platformName的第一个字
						"avatarColor": "#4A148C" // 深色对比
				},
				{
						"platformName": "堆友AI反应堆",
						"intro": "阿里旗下堆友推出的多风格AI绘画生成器",
						"link": "https://d.design/?sharecode=duVZgOFyKX",
						"logo": "d-design-ai-icon.png",
						"sort": 214,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB91", // 浅橙色背景
						"avatarName": "堆", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "PhotoStudio AI",
						"intro": "AI商拍工具，虹软旗下推出",
						"link": "https://psai.cn/?source_id=1000",
						"logo": "photostudio-ai-icon.png",
						"sort": 215,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2EBF2", // 浅蓝色背景
						"avatarName": "P", // platformName的第一个字
						"avatarColor": "#006064" // 深色对比
				},
				{
						"platformName": "可图 KOLORS",
						"intro": "快手推出的免费AI图像生成平台",
						"link": "https://kolors.kuaishou.com/?utm_source=huyaai.cn",
						"logo": "kuaishou-kolors-icon.png",
						"sort": 216,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅桃色背景
						"avatarName": "可", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				// {
				// 		"platformName": "Midjourney",
				// 		"intro": "AI图像和插画生成工具",
				// 		"link": "https://cn.bing.com/search?q=Midjourney&ensearch=1",
				// 		"logo": "midjourney-icon.png",
				// 		"sort": 217,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#E1BEE7", // 浅紫色背景
				// 		"avatarName": "M", // platformName的第一个字
				// 		"avatarColor": "#4A148C" // 深色对比
				// },
				// {
				// 		"platformName": "Stable Diffusion",
				// 		"intro": "StabilityAI推出的文本到图像生成AI",
				// 		"link": "https://cn.bing.com/search?q=Stable Diffusion&ensearch=1",
				// 		"logo": "stability-ai-icon.png",
				// 		"sort": 218,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#B2DFDB", // 浅青色背景
				// 		"avatarName": "S", // platformName的第一个字
				// 		"avatarColor": "#004D40" // 深色对比
				// },
				{
						"platformName": "LiblibAI·哩布哩布AI",
						"intro": "国内领先的AI图像创作平台和模型分享社区",
						"link": "https://www.liblib.art/?utm_source=huyaai.cn",
						"logo": "liblibai-icon.png",
						"sort": 219,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅桃色背景
						"avatarName": "L", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "BigJPG",
						"intro": "免费的在线图片无损放大工具",
						"link": "https://bigjpg.com/",
						"logo": "bigjpg-icon.png",
						"sort": 220,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB91", // 浅橙色背景
						"avatarName": "B", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "文心一格",
						"intro": "AI艺术和创意辅助平台",
						"link": "https://yige.baidu.com/",
						"logo": "paddlepaddle-icon.png",
						"sort": 221,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D1C4E9", // 浅紫色背景
						"avatarName": "文", // platformName的第一个字
						"avatarColor": "#4A148C" // 深色对比
				},
				{
						"platformName": "超能画布",
						"intro": "百度网盘推出的AI创意图像写真创作平台",
						"link": "https://photo.baidu.com/photasy/home?utm_source=huyaai.cn",
						"logo": "photasy-icon.png",
						"sort": 222,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅桃色背景
						"avatarName": "超", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "OneStory",
						"intro": "AI故事生成助手，创作故事和视频变得像说话一样简单",
						"link": "https://onestory.art/?utm_source=huyaai.cn",
						"logo": "OneStory-logo.png",
						"sort": 223,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2DFDB", // 浅青色背景
						"avatarName": "O", // platformName的第一个字
						"avatarColor": "#004D40" // 深色对比
				},
				{
						"platformName": "Bing Image Creator",
						"intro": "微软必应推出的基于DALL·E的AI图像生成工具",
						"link": "https://www.bing.com/images/create?utm_source=huyaai.cn",
						"logo": "new-bing-icon.png",
						"sort": 224,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB91", // 浅橙色背景
						"avatarName": "B", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "WHEE",
						"intro": "美图推出的AI图片和绘画创作生成平台",
						"link": "https://www.whee.com/?utm_source=huyaai.cn",
						"logo": "whee-logo.png",
						"sort": 225,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D1C4E9", // 浅紫色背景
						"avatarName": "W", // platformName的第一个字
						"avatarColor": "#4A148C" // 深色对比
				},
				{
						"platformName": "DeepSwapper",
						"intro": "免费的在线AI换脸工具，支持图片、视频多种格式",
						"link": "https://www.deepswapper.com/?utm_source=huyaai.cn",
						"logo": "DeepSwapper-logo-1.png",
						"sort": 226,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅桃色背景
						"avatarName": "D", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				// {
				// 		"platformName": "Adobe Firefly",
				// 		"intro": "Adobe最新推出的AI图片生成工具",
				// 		"link": "https://cn.bing.com/search?q=Adobe Firefly&ensearch=1",
				// 		"logo": "adobe-icon.png",
				// 		"sort": 227,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFAB91", // 浅橙色背景
				// 		"avatarName": "A", // platformName的第一个字
				// 		"avatarColor": "#BF360C" // 深色对比
				// },
				{
						"platformName": "笔魂AI绘画",
						"intro": "AI绘画工具，支持文生图和以图生图",
						"link": "https://ibihun.com/?hf=10",
						"logo": "ibihun-logo-1.png",
						"sort": 228,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2DFDB", // 浅青色背景
						"avatarName": "笔", // platformName的第一个字
						"avatarColor": "#004D40" // 深色对比
				},
				{
						"platformName": "ClipDrop",
						"intro": "Stability.ai推出的AI图片处理系列工具",
						"link": "https://clipdrop.co/",
						"logo": "clipdrop-icon.png",
						"sort": 229,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅桃色背景
						"avatarName": "C", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "图查查",
						"intro": "360推出的AI作图平台，提供智能抠图、智能消除、智能放大、智能配图等功能",
						"link": "https://chacha.so.com/home?utm_source=huyaai.cn",
						"logo": "chacha-so-icon.png",
						"sort": 230,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D1C4E9", // 浅紫色背景
						"avatarName": "图", // platformName的第一个字
						"avatarColor": "#4A148C" // 深色对比
				},
				{
						"platformName": "Booltool",
						"intro": "在线AI6箱",
						"link": "https://booltool.boolv.tech/home",
						"logo": "booltool-icon.png",
						"sort": 231,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB91", // 浅橙色背景
						"avatarName": "B", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "PhotoRoom",
						"intro": "免费的AI图片背景移除和添加",
						"link": "https://www.photoroom.com/background-remover",
						"logo": "photoroom-icon.png",
						"sort": 232,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2DFDB", // 浅青色背景
						"avatarName": "P", // platformName的第一个字
						"avatarColor": "#004D40" // 深色对比
				},
				{
						"platformName": "remove.bg",
						"intro": "强大的AI图片背景移除工具",
						"link": "https://www.remove.bg/zh?aid=kkgjrdhppgtrhbyn&utm_campaign=affiliate+marketing&utm_medium=referral&utm_source=affiliate",
						"logo": "remove-bg-icon.png",
						"sort": 233,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅桃色背景
						"avatarName": "移", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "Hama",
						"intro": "在线抹除图片中不想要的物体",
						"link": "https://www.hama.app/zh",
						"logo": "hama-app-icon.png",
						"sort": 234,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D1C4E9", // 浅紫色背景
						"avatarName": "哈", // platformName的第一个字
						"avatarColor": "#4A148C" // 深色对比
				},
				{
						"platformName": "造梦日记",
						"intro": "AI一下，妙笔生画",
						"link": "https://zmrj.art/?utm_source=huyaai.cn",
						"logo": "printidea-art-icon.png",
						"sort": 235,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB91", // 浅橙色背景
						"avatarName": "造", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "IconGen",
						"intro": "免费的icon图标AI生成器",
						"link": "https://www.icongen.io/?utm_source=huyaai.cn",
						"logo": "IconGen.io-logo.png",
						"sort": 236,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2DFDB", // 浅青色背景
						"avatarName": "I", // platformName的第一个字
						"avatarColor": "#004D40" // 深色对比
				},
				{
						"platformName": "美图AI文生图",
						"intro": "美图推出的AI文本生成图片的工具",
						"link": "https://design.meitu.com/aigc/text-to-image?from=huyaai.cn",
						"logo": "meitu-aigc-icon.png",
						"sort": 237,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅桃色背景
						"avatarName": "美", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "Ribbet.ai",
						"intro": "免费的多功能AI图片处理工具箱",
						"link": "https://ribbet.ai/",
						"logo": "ribbet-ai-icon.png",
						"sort": 238,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D1C4E9", // 浅紫色背景
						"avatarName": "R", // platformName的第一个字
						"avatarColor": "#4A148C" // 深色对比
				},
				{
						"platformName": "ARC",
						"intro": "腾讯旗下ARC实验室推出的免费AI图片处理工具",
						"link": "https://arc.tencent.com/zh/ai-demos/",
						"logo": "tencent-arc-icon.png",
						"sort": 239,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB91", // 浅橙色背景
						"avatarName": "A", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "悟空图像PhotoSir",
						"intro": "新一代专业图像处理软件，更智能、更高效、更好用",
						"link": "https://www.photosir.com/?ref=huyaai.cn",
						"logo": "photosir-icon.png",
						"sort": 240,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B2DFDB", // 浅青色背景
						"avatarName": "悟", // platformName的第一个字
						"avatarColor": "#004D40" // 深色对比
				},
				{
						"platformName": "如果相机",
						"intro": "仅需1张照片，快速生成AI写真照片",
						"link": "https://ifshot.com/?utm_source=huyaai.cn",
						"logo": "logo.png",
						"sort": 241,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅桃色背景
						"avatarName": "如", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "PicTech AI",
						"intro": "免费的在线图片翻译工具，支持一键抠图",
						"link": "https://www.pictech.cc/?utm_source=huyaai.cn",
						"logo": "PicTech-AI-logo.png",
						"sort": 242,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D1C4E9", // 浅紫色背景
						"avatarName": "P", // platformName的第一个字
						"avatarColor": "#4A148C" // 深色对比
				},
				// {
				// 		"platformName": "Relight",
				// 		"intro": "ClipDrop推出的AI图像打光工具",
				// 		"link": "https://clipdrop.co/relight",
				// 		"logo": "clipdrop-relight-icon-1.png",
				// 		"sort": 243,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFAB91", // 浅橙色背景
				// 		"avatarName": "R", // platformName的第一个字
				// 		"avatarColor": "#BF360C" // 深色对比
				// },
				// {
				// 		"platformName": "Cutout.Pro",
				// 		"intro": "AI在线处理图片",
				// 		"link": "https://www.cutout.pro/",
				// 		"logo": "cutout-pro-icon.png",
				// 		"sort": 244,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#B2DFDB", // 浅青色背景
				// 		"avatarName": "C", // platformName的第一个字
				// 		"avatarColor": "#004D40" // 深色对比
				// },
				{
						"platformName": "AI设计师",
						"intro": "AI万能图片在线编辑器",
						"link": "https://img.logosc.cn/?utm_source=huyaai.cn",
						"logo": "img-logosc-icon.png",
						"sort": 245,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅桃色背景
						"avatarName": "A", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "MagicStudio",
						"intro": "高颜值AI图像处理工具",
						"link": "https://magicstudio.com/zh",
						"logo": "magicstudio-icon.png",
						"sort": 246,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D1C4E9", // 浅紫色背景
						"avatarName": "M", // platformName的第一个字
						"avatarColor": "#4A148C" // 深色对比
				},
				{
						"platformName": "canva可画",
						"intro": "绘画、文字素材",
						"link": "https://www.canva.cn/",
						"logo": "1.png",
						"sort": 247,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB91", // 浅橙色背景
						"avatarName": "可", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				}
		]
},
{
		"categoryName": "视频工具",
		"clientUserThirdPartyAccountResponses": [
				{
						"platformName": "白日梦",
						"intro": "AI视频创作平台，最长可生成六分钟的视频",
						"link": "https://aibrm.com?code=fx_zzpx",
						"logo": "aibrm-icon.png",
						"sort": 248,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "白", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				{
						"platformName": "腾讯智影",
						"intro": "腾讯推出的在线智能视频创作平台",
						"link": "https://zenvideo.qq.com/",
						"logo": "zenvideo-qq-icon.png",
						"sort": 249,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB40", // 橙色背景
						"avatarName": "腾", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "可灵大模型",
						"intro": "快手推出的视频生成大模型，可生成2分钟的视频",
						"link": "https://kling.kuaishou.com/?utm_source=huyaai.cn",
						"logo": "kling-ai-icon.png",
						"sort": 250,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C5E1A5", // 浅绿色背景
						"avatarName": "可", // platformName的第一个字
						"avatarColor": "#4A148C" // 深色对比
				},
				{
						"platformName": "Vidu",
						"intro": "生数科技与清华大学联合发布的视频大模型",
						"link": "https://www.vidu.studio/?utm_source=huyaai.cn",
						"logo": "vidu-logo.jpg",
						"sort": 251,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅桃色背景
						"avatarName": "V", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "Vozo",
						"intro": "集一键重写脚本、配音、对口型、翻译于一体的AI视频编辑工具",
						"link": "https://www.vozo.ai/?utm_source=huyaai.cn",
						"logo": "Vozo-logo.png",
						"sort": 252,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB91", // 浅橙色背景
						"avatarName": "V", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "Vizard",
						"intro": "将长视频转换为社交短视频片段的AI8",
						"link": "https://vizard.ai/?utm_source=huyaai.cn",
						"logo": "Vizard.ai-logo.png",
						"sort": 253,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D1C4E9", // 浅紫色背景
						"avatarName": "V", // platformName的第一个字
						"avatarColor": "#4A148C" // 深色对比
				},
				// {
				// 		"platformName": "Noisee AI",
				// 		"intro": "月之暗面旗下推出的AI音乐视频MV生成工具",
				// 		"link": "https://noisee.ai/?utm_source=huyaai.cn",
				// 		"logo": "noisee-ai-icon.png",
				// 		"sort": 254,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#B2DFDB", // 浅青色背景
				// 		"avatarName": "N", // platformName的第一个字
				// 		"avatarColor": "#004D40" // 深色对比
				// },
				{
						"platformName": "Sora",
						"intro": "OpenAI推出的AI文本到视频生成模型",
						"link": "https://openai.com/sora?ref=huyaai.cn",
						"logo": "openai-gpt-model.png",
						"sort": 255,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅桃色背景
						"avatarName": "S", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "Viggle",
						"intro": "AI生成角色动态视频的工具",
						"link": "https://viggle.ai/?ref=huyaai.cn",
						"logo": "viggle-ai-icon.png",
						"sort": 256,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D1C4E9", // 浅紫色背景
						"avatarName": "V", // platformName的第一个字
						"avatarColor": "#4A148C" // 深色对比
				},
				// {
				// 		"platformName": "Runway",
				// 		"intro": "强大的AI视频制作工具，绿幕抠像、视频合成等",
				// 		"link": "https://runwayml.com/green-screen/",
				// 		"logo": "runwayml-icon.png",
				// 		"sort": 257,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFAB91", // 浅橙色背景
				// 		"avatarName": "R", // platformName的第一个字
				// 		"avatarColor": "#BF360C" // 深色对比
				// },
				{
						"platformName": "万兴播爆",
						"intro": "AI数字人口播视频营销工具（可商用），海量素材一键套用",
						"link": "https://virbo.wondershare.cn/promotion-invitee.html?code=1YIvqeQui1C",
						"logo": "virbo-wondershare-icon.png",
						"sort": 258,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "万", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				{
						"platformName": "有言",
						"intro": "一站式AI视频创作，1200+免费3D数字人",
						"link": "https://youyan.xyz/platform/home/prime?from=huyaai.cn",
						"logo": "youyan-icon.png",
						"sort": 259,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅桃色背景
						"avatarName": "有", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "一帧秒创",
						"intro": "简单好用的AI智能视频创作平台",
						"link": "https://aigc.yizhentv.com/product/imageTextToVideo?_f=huyaai.cn",
						"logo": "aigc-yizhentv-icon.png",
						"sort": 260,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C5E1A5", // 浅绿色背景
						"avatarName": "一", // platformName的第一个字
						"avatarColor": "#4A148C" // 深色对比
				},
				// {
				// 		"platformName": "Dream Machine",
				// 		"intro": "Luma推出的AI视频生成工具，120秒内可生成120帧视频",
				// 		"link": "https://lumalabs.ai/dream-machine?utm_source=huyaai.cn",
				// 		"logo": "dream-machine-icon.png",
				// 		"sort": 261,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFAB40", // 橙色背景
				// 		"avatarName": "D", // platformName的第一个字
				// 		"avatarColor": "#BF360C" // 深色对比
				// },
				{
						"platformName": "Stable Video",
						"intro": "Stability AI上线的AI视频生成工具",
						"link": "https://www.stablevideo.com/?utm_source=huyaai.cn",
						"logo": "stable-video-icon.png",
						"sort": 262,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "S", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				{
						"platformName": "即创",
						"intro": "抖音推出的一站式智能创作平台，支持视频、图文和直播创作",
						"link": "https://aic.oceanengine.com/?from=huyaai.cn",
						"logo": "aic-oceanengine-icon.png",
						"sort": 263,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅桃色背景
						"avatarName": "即", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				// {
				// 		"platformName": "YoYo",
				// 		"intro": "鹿影科技推出的二次元动漫AI视频生成平台",
				// 		"link": "https://avolutionai.com/?utm_source=huyaai.cn",
				// 		"logo": "yoyo-logo.png",
				// 		"sort": 264,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#C5E1A5", // 浅绿色背景
				// 		"avatarName": "Y", // platformName的第一个字
				// 		"avatarColor": "#4A148C" // 深色对比
				// },
				{
						"platformName": "巨日禄",
						"intro": "一站式AI动漫视频创作平台",
						"link": "https://ai.jurilu.com/?utm_source=huyaai.cn",
						"logo": "jurilu.png",
						"sort": 265,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB40", // 橙色背景
						"avatarName": "巨", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "Hedra",
						"intro": "AI对口型视频生成工具，单次可免费生成30秒的视频",
						"link": "https://www.hedra.com/?utm_source=huyaai.cn",
						"logo": "hedra-icon.png",
						"sort": 266,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "H", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				{
						"platformName": "寻光",
						"intro": "阿里达摩院推出的全流程AI视频创作平台",
						"link": "https://xunguang.damo-vision.com/?utm_source=huyaai.cn",
						"logo": "ali-xunguang-icon.png",
						"sort": 267,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅桃色背景
						"avatarName": "寻", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "D-ID",
						"intro": "AI真人口播视频生成工具",
						"link": "https://cn.bing.com/search?q=D-ID&ensearch=1",
						"logo": "d-id-icon.png",
						"sort": 268,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C5E1A5", // 浅绿色背景
						"avatarName": "D", // platformName的第一个字
						"avatarColor": "#4A148C" // 深色对比
				},
				{
						"platformName": "度加创作工具",
						"intro": "百度官方出品的AIGC创作平台",
						"link": "https://aigc.baidu.com/?utm_source=huyaai.cn",
						"logo": "aigc-baidu-icon.png",
						"sort": 269,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB40", // 橙色背景
						"avatarName": "度", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "Viva",
						"intro": "免费的AI视频生成和图像创作平台",
						"link": "https://vivago.ai/?utm_source=huyaai.cn",
						"logo": "viva-ai-icon.png",
						"sort": 270,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "V", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				{
						"platformName": "Spikes Studio",
						"intro": "AI自动将长视频切片剪辑为短视频",
						"link": "https://spikes.studio/?ref=uS3c5lzVrr",
						"logo": "spikes-studio-icon.png",
						"sort": 271,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅桃色背景
						"avatarName": "S", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "Morph Studio",
						"intro": "高质量的AI文本到视频生成工具",
						"link": "https://www.morphstudio.com/?ref=huyaai.cn",
						"logo": "morph-studio-icon.png",
						"sort": 272,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C5E1A5", // 浅绿色背景
						"avatarName": "M", // platformName的第一个字
						"avatarColor": "#4A148C" // 深色对比
				},
				{
						"platformName": "必剪Studio",
						"intro": "B站推出的免费AI数字分身定制和视频创作工具",
						"link": "https://member.bilibili.com/york/bilibili-studio/?utm_source=huyaai.cn",
						"logo": "bilibili-studio-logo.png",
						"sort": 273,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB40", // 橙色背景
						"avatarName": "必", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "曦灵",
						"intro": "百度推出的AI数字人和视频创作平台",
						"link": "https://xiling.cloud.baidu.com/?utm_source=huyaai.cn",
						"logo": "baidu-xiling-icon.png",
						"sort": 274,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "曦", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				{
						"platformName": "开拍",
						"intro": "美图推出的AI口播视频制作工具",
						"link": "https://kaipai.meitu.com/?ref=huyaai.cn",
						"logo": "kaipai-icon.png",
						"sort": 275,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅桃色背景
						"avatarName": "开", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "Duix",
						"intro": "硅基智能推出的AI数字人生成平台",
						"link": "https://www.duix.ai/duix-app-landing-page/#/home?utm_source=huyaai.cn",
						"logo": "duix-icon.png",
						"sort": 276,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C5E1A5", // 浅绿色背景
						"avatarName": "D", // platformName的第一个字
						"avatarColor": "#4A148C" // 深色对比
				},
				{
						"platformName": "MOKI",
						"intro": "美图推出的AI视频短片创作工具",
						"link": "https://www.moki.cn/?utm_source=huyaai.cn",
						"logo": "moki-icon.png",
						"sort": 277,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB40", // 橙色背景
						"avatarName": "M", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				// {
				// 		"platformName": "Vimi",
				// 		"intro": "商汤科技推出的可控人物视频生成AI模型",
				// 		"link": "https://www.sensetime.com/cn/product-detail?categoryId=51134571&gioNav=1",
				// 		"logo": "vimi-icon.png",
				// 		"sort": 278,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#B0BEC5", // 灰蓝色背景
				// 		"avatarName": "V", // platformName的第一个字
				// 		"avatarColor": "#263238" // 深色对比
				// },
				{
						"platformName": "场辞",
						"intro": "新片场推出的AI视频字幕制作工具",
						"link": "https://trans.xinpianchang.com/?utm_source=huyaai.cn",
						"logo": "xinpianchang-trans-logo.png",
						"sort": 279,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅桃色背景
						"avatarName": "场", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "KreadoAI",
						"intro": "AI数字人视频营销创作平台",
						"link": "https://kreadoai.com/?utm_source=huyaai.cn",
						"logo": "kreadoai-icon.png",
						"sort": 280,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C5E1A5", // 浅绿色背景
						"avatarName": "K", // platformName的第一个字
						"avatarColor": "#4A148C" // 深色对比
				},
				{
						"platformName": "Haiper",
						"intro": "AI视频生成和重绘工具，支持文本/图像转视频",
						"link": "https://haiper.ai/?ref=huyaai.cn",
						"logo": "haiper-ai-icon.png",
						"sort": 281,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB40", // 橙色背景
						"avatarName": "H", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "星火绘镜",
						"intro": "科大讯飞推出的AI短视频创作平台",
						"link": "https://typemovie.art/?utm_source=huyaai.cn#/dashboard/",
						"logo": "typemovie-icon.png",
						"sort": 282,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "星", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				{
						"platformName": "Google Vids",
						"intro": "谷歌推出的AI视频创作工具",
						"link": "https://workspace.google.com/products/vids/?ref=huyaai.cn",
						"logo": "google-vids-icon.png",
						"sort": 283,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅桃色背景
						"avatarName": "G", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "WinkStudio",
						"intro": "美图推出的桌面端AI视频剪辑工具",
						"link": "https://wink.meitu.com/?ref=huyaai.cn",
						"logo": "winkstudio-icon.png",
						"sort": 284,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C5E1A5", // 浅绿色背景
						"avatarName": "W", // platformName的第一个字
						"avatarColor": "#4A148C" // 深色对比
				},
				{
						"platformName": "DomoAI",
						"intro": "一键将照片和视频动漫化的AI工具",
						"link": "https://domoai.app/?ref=huyaai.cn",
						"logo": "domoai-icon.png",
						"sort": 285,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFAB40", // 橙色背景
						"avatarName": "D", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				},
				{
						"platformName": "Gatekeep",
						"intro": "AI教学视频生成工具，可生成数学物理问题解释视频",
						"link": "https://gatekeep.ai/?ref=huyaai.cn",
						"logo": "gatekeep-ai-icon.png",
						"sort": 286,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0BEC5", // 灰蓝色背景
						"avatarName": "G", // platformName的第一个字
						"avatarColor": "#263238" // 深色对比
				},
				{
						"platformName": "Showrunner",
						"intro": "AI动画视频剧集生成工具",
						"link": "https://www.showrunner.xyz/?utm_source=huyaai.cn",
						"logo": "showrunner-icon.png",
						"sort": 287,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFCCBC", // 浅桃色背景
						"avatarName": "S", // platformName的第一个字
						"avatarColor": "#BF360C" // 深色对比
				}
		]
},
{
		"categoryName": "编程工具",
		"clientUserThirdPartyAccountResponses": [
				{
						"platformName": "通义灵码",
						"intro": "阿里推出的免费AI9，基于通义大模型",
						"link": "https://click.aliyun.com/m/1000395707/",
						"logo": "tongyi-lingma-icon-1.png",
						"sort": 288,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#A8DADC", // 浅蓝色背景
						"avatarName": "通", // platformName的第一个字
						"avatarColor": "#1D3557" // 深色对比
				},
				{
						"platformName": "腾讯云AI代码助手",
						"intro": "腾讯推出的AI编程辅助工具",
						"link": "https://cloud.tencent.com/product/acc?utm_source=huyaai.cn",
						"logo": "tencent-cloud-ai-code-assistant-icon.png",
						"sort": 289,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F1FAEE", // 浅绿色背景
						"avatarName": "腾", // platformName的第一个字
						"avatarColor": "#457B9D" // 深色对比
				},
				{
						"platformName": "豆包MarsCode",
						"intro": "字节旗下推出的免费AI编程助手",
						"link": "https://www.marscode.cn/?utm_source=huyaai.cn",
						"logo": "marscode-icon.png",
						"sort": 290,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F8CBA6", // 浅橙色背景
						"avatarName": "豆", // platformName的第一个字
						"avatarColor": "#D00000" // 深色对比
				},
				{
						"platformName": "文心快码",
						"intro": "百度推出的AI编程助手，基于文心大模型",
						"link": "https://comate.baidu.com/?utm_source=huyaai.cn",
						"logo": "comate-baidu-logo.png",
						"sort": 291,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFE5B4", // 浅黄色背景
						"avatarName": "文", // platformName的第一个字
						"avatarColor": "#5B3A29" // 深色对比
				},
				{
						"platformName": "代码小浣熊Raccoon",
						"intro": "商汤科技推出的免费AI编程助手",
						"link": "https://raccoon.sensetime.com/code?utm_source=bljuly01",
						"logo": "sensetime-raccoon-code-icon.png",
						"sort": 292,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D9D9D9", // 灰色背景
						"avatarName": "代", // platformName的第一个字
						"avatarColor": "#1F1F1F" // 深色对比
				},
				{
						"platformName": "BigModel",
						"intro": "智谱AI推出的大模型开发平台，新用户免费领取2500万Tokens",
						"link": "https://bigmodel.cn/login?utm_campaign=huyaai.cn&_channel_track_key=vqYFLTGW",
						"logo": "BigModel-logo.png",
						"sort": 293,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F0E5D8", // 浅米色背景
						"avatarName": "B", // platformName的第一个字
						"avatarColor": "#3C3C3C" // 深色对比
				},
				{
						"platformName": "GitHub Copilot",
						"intro": "改成GitHub推出的编程工具",
						"link": "https://github.com/features/copilot",
						"logo": "github-copilot-icon.png",
						"sort": 294,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C4C4C4", // 灰色背景
						"avatarName": "G", // platformName的第一个字
						"avatarColor": "#000000" // 深色对比
				},
				{
						"platformName": "Tabby",
						"intro": "免费开源的自托管AI编程助手",
						"link": "https://tabby.tabbyml.com/?ref=huyaai.cn",
						"logo": "tabby-ai-icon.png",
						"sort": 295,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#E0E0E0", // 浅灰色背景
						"avatarName": "T", // platformName的第一个字
						"avatarColor": "#3A3A3A" // 深色对比
				},
				{
						"platformName": "C知道",
						"intro": "CSDN推出的AI技术问答工具",
						"link": "https://so.csdn.net/chat?utm_source=huyaai.cn",
						"logo": "so-csdn-logo.png",
						"sort": 296,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0E0E6", // 浅蓝色背景
						"avatarName": "C", // platformName的第一个字
						"avatarColor": "#2F4F4F" // 深色对比
				},
				{
						"platformName": "驭码CodeRider",
						"intro": "极狐GitLab推出的AI编程与软件智能研发助手",
						"link": "https://coderider.gitlab.cn/?utm_source=huyaai.cn",
						"logo": "coderider-icon.png",
						"sort": 297,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFE4E1", // 浅粉色背景
						"avatarName": "驭", // platformName的第一个字
						"avatarColor": "#8B0000" // 深色对比
				},
				{
						"platformName": "Duo Chat",
						"intro": "GitLab推出的AI编程助手",
						"link": "https://about.gitlab.com/gitlab-duo/?utm_source=huyaai.cn",
						"logo": "gitlab-duo-chat-icon.png",
						"sort": 298,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D3D3D3", // 浅灰色背景
						"avatarName": "D", // platformName的第一个字
						"avatarColor": "#696969" // 深色对比
				},
				{
						"platformName": "CodeRabbit",
						"intro": "AI驱动的代码审查平台",
						"link": "https://coderabbit.ai/?utm_source=huyaai.cn",
						"logo": "coderabbit-icon.png",
						"sort": 299,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5DC", // 浅米色背景
						"avatarName": "C", // platformName的第一个字
						"avatarColor": "#4B0082" // 深色对比
				},
				{
						"platformName": "Augment",
						"intro": "AI编程辅助工具，专为大型代码库设计",
						"link": "https://www.augmentcode.com/?utm_source=huyaai.cn",
						"logo": "augment-code-icon.png",
						"sort": 300,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#E6E6FA", // 浅紫色背景
						"avatarName": "A", // platformName的第一个字
						"avatarColor": "#483D8B" // 深色对比
				},
				{
						"platformName": "Devin",
						"intro": "首个全自主的AI软件工程师智能体",
						"link": "https://preview.devin.ai/?ref=huyaai.cn",
						"logo": "devin-ai.png",
						"sort": 301,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFF0F5", // 浅粉色背景
						"avatarName": "D", // platformName的第一个字
						"avatarColor": "#8B008B" // 深色对比
				},
				{
						"platformName": "ChatDev",
						"intro": "面壁智能推出的AI智能体软件开发平台，使用自然语言即可创建软件",
						"link": "https://chatdev.modelbest.cn/?ref=huyaai.cn",
						"logo": "chatdev-icon.png",
						"sort": 302,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F0FFF0", // 浅绿色背景
						"avatarName": "C", // platformName的第一个字
						"avatarColor": "#006400" // 深色对比
				},
				{
						"platformName": "v0.dev",
						"intro": "AI生成前端React/UI组件，由Vercel推出",
						"link": "https://v0.dev/?ref=huyaai.cn",
						"logo": "v0-dev-icon.png",
						"sort": 303,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D8BFD8", // 浅紫色背景
						"avatarName": "v", // platformName的第一个字
						"avatarColor": "#4B0082" // 深色对比
				},
				{
						"platformName": "Boxy",
						"intro": "CodeSandbox推出的AI编程助手",
						"link": "https://codesandbox.io/blog/meet-boxy-ai-coding-assistant",
						"logo": "codesandbox-boxy-icon.png",
						"sort": 304,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFEFD5", // 浅杏色背景
						"avatarName": "B", // platformName的第一个字
						"avatarColor": "#8B4513" // 深色对比
				},
				{
						"platformName": "Quest AI",
						"intro": "AI将设计稿生成React代码，支持JavaScript和TypeScript",
						"link": "https://www.quest.ai/?utm_source=huyaai.cn",
						"logo": "quest-ai-icon.png",
						"sort": 305,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#E6E6FA", // 浅紫色背景
						"avatarName": "Q", // platformName的第一个字
						"avatarColor": "#4B0082" // 深色对比
				},
				{
						"platformName": "Cursor",
						"intro": "AI代码编辑器，快速进行编程和软件开发",
						"link": "https://www.cursor.com/?utm_source=huyaai.cn",
						"logo": "cursor-logo.png",
						"sort": 306,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5F5", // 浅灰色背景
						"avatarName": "C", // platformName的第一个字
						"avatarColor": "#696969" // 深色对比
				},
				{
						"platformName": "Project IDX",
						"intro": "谷歌推出的AI云端开发和代码编辑器",
						"link": "https://idx.dev/?utm_source=huyaai.cn",
						"logo": "project-idx-icon.png",
						"sort": 307,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D3D3D3", // 浅灰色背景
						"avatarName": "P", // platformName的第一个字
						"avatarColor": "#2F4F4F" // 深色对比
				},
				{
						"platformName": "CodeGeeX",
						"intro": "智谱AI推出的免费AI编程助手",
						"link": "https://codegeex.cn/zh-CN",
						"logo": "codegeex-icon.png",
						"sort": 308,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F0E68C", // 浅黄色背景
						"avatarName": "C", // platformName的第一个字
						"avatarColor": "#8B0000" // 深色对比
				},
				{
						"platformName": "iFlyCode",
						"intro": "科大讯飞推出的智能编程助手",
						"link": "https://iflycode.xfyun.cn/?utm_source=huyaai.cn",
						"logo": "iflycode-icon.png",
						"sort": 309,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#E0FFFF", // 浅蓝色背景
						"avatarName": "i", // platformName的第一个字
						"avatarColor": "#00008B" // 深色对比
				},
				{
						"platformName": "Cody",
						"intro": "Sourcegraph推出的编程工具",
						"link": "https://about.sourcegraph.com/cody?utm_source=huyaai.cn",
						"logo": "sourcegraph-cody-icon.png",
						"sort": 310,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5F5", // 浅灰色背景
						"avatarName": "C", // platformName的第一个字
						"avatarColor": "#696969" // 深色对比
				},
				{
						"platformName": "CodeWhisperer",
						"intro": "亚马逊推出的免费AI编程助手",
						"link": "https://aws.amazon.com/codewhisperer/",
						"logo": "codewhisperer-icon.png",
						"sort": 311,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D8BFD8", // 浅紫色背景
						"avatarName": "C", // platformName的第一个字
						"avatarColor": "#4B0082" // 深色对比
				},
				{
						"platformName": "Codeium",
						"intro": "免费的AI9，智能生成和补全代码",
						"link": "https://www.codeium.com/",
						"logo": "codeium-icon.png",
						"sort": 312,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#E6E6FA", // 浅紫色背景
						"avatarName": "C", // platformName的第一个字
						"avatarColor": "#4B0082" // 深色对比
				},
				// {
				// 		"platformName": "DevChat",
				// 		"intro": "开源的支持多款大模型的AI编程助手",
				// 		"link": "https://www.devchat.ai/zh?ref=huyaai.cn",
				// 		"logo": "devchat-icon.png",
				// 		"sort": 313,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#F0F8FF", // 浅蓝色背景
				// 		"avatarName": "D", // platformName的第一个字
				// 		"avatarColor": "#00008B" // 深色对比
				// },
				// {
				// 		"platformName": "Sketch2Code",
				// 		"intro": "微软AI Lab推出的将手绘草图转换成HTML代码工具",
				// 		"link": "https://sketch2code.azurewebsites.net/",
				// 		"logo": "sketch2code-icon.png",
				// 		"sort": 314,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFF5EE", // 浅粉色背景
				// 		"avatarName": "S", // platformName的第一个字
				// 		"avatarColor": "#8B0000" // 深色对比
				// },
				{
						"platformName": "CodiumAI",
						"intro": "免费的AI代码测试和分析工具",
						"link": "https://www.codium.ai/",
						"logo": "codiumai-icon.png",
						"sort": 315,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D3D3D3", // 浅灰色背景
						"avatarName": "C", // platformName的第一个字
						"avatarColor": "#696969" // 深色对比
				},
				{
						"platformName": "CodeFuse",
						"intro": "蚂蚁集团推出的AI代码编程助手",
						"link": "https://codefuse.alipay.com/?ref=huyaai.cn",
						"logo": "codefuse-icon.png",
						"sort": 316,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5DC", // 浅米色背景
						"avatarName": "C", // platformName的第一个字
						"avatarColor": "#4B0082" // 深色对比
				},
				{
						"platformName": "天工智码Skycode",
						"intro": "AI智能编程助手，轻松生成各种代码",
						"link": "https://sky-code.singularity-ai.com/index.html#/",
						"logo": "skycode-icon-1.png",
						"sort": 317,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#E0FFFF", // 浅蓝色背景
						"avatarName": "天", // platformName的第一个字
						"avatarColor": "#00008B" // 深色对比
				},
				{
						"platformName": "Plandex",
						"intro": "免费开源的基于终端的AI编程引擎",
						"link": "https://plandex.ai/?ref=huyaai.cn",
						"logo": "plandex-icon.png",
						"sort": 318,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5F5", // 浅灰色背景
						"avatarName": "P", // platformName的第一个字
						"avatarColor": "#696969" // 深色对比
				},
				{
						"platformName": "Fitten Code",
						"intro": "非十科技推出的免费AI代码助手",
						"link": "https://code.fittentech.com/?ref=huyaai.cn",
						"logo": "fitten-code-icon.png",
						"sort": 319,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFE4E1", // 浅粉色背景
						"avatarName": "F", // platformName的第一个字
						"avatarColor": "#8B0000" // 深色对比
				},
				{
						"platformName": "BLACKBOX AI",
						"intro": "黑箱AI编程助理，快速代码生成",
						"link": "https://www.useblackbox.io/?ref=huyaai.cn",
						"logo": "blackbox-ai-icon.png",
						"sort": 320,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D3D3D3", // 浅灰色背景
						"avatarName": "B", // platformName的第一个字
						"avatarColor": "#696969" // 深色对比
				},
				{
						"platformName": "Solo",
						"intro": "Mozilla推出的零编程无代码AI网站建设工具",
						"link": "https://soloist.ai/?ref=huyaai.cn",
						"logo": "solo-ai-website-composer-icon.png",
						"sort": 321,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5F5", // 浅灰色背景
						"avatarName": "S", // platformName的第一个字
						"avatarColor": "#696969" // 深色对比
				},
				{
						"platformName": "JetBrains AI",
						"intro": "JetBrains推出的AI编程开发助手",
						"link": "https://www.jetbrains.com/ai/?ref=huyaai.cn",
						"logo": "jetbrains-ai-icon.png",
						"sort": 322,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D3D3D3", // 浅灰色背景
						"avatarName": "J", // platformName的第一个字
						"avatarColor": "#696969" // 深色对比
				},
				{
						"platformName": "CodeArts Snap",
						"intro": "华为云推出的智能编程助手",
						"link": "https://www.huaweicloud.com/product/codeartside/snap.html",
						"logo": "codearts-snap-icon.png",
						"sort": 323,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5F5", // 浅灰色背景
						"avatarName": "C", // platformName的第一个字
						"avatarColor": "#696969" // 深色对比
				},
				{
						"platformName": "AskCodi",
						"intro": "你的个人AI编程助手",
						"link": "https://www.askcodi.com/",
						"logo": "askcodi-icon.png",
						"sort": 324,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5F5", // 浅灰色背景
						"avatarName": "A", // platformName的第一个字
						"avatarColor": "#696969" // 深色对比
				},
				{
						"platformName": "JamGPT",
						"intro": "AI Debug调试助手",
						"link": "https://jam.dev/jamgpt",
						"logo": "jamgpt-icon.png",
						"sort": 325,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5F5", // 浅灰色背景
						"avatarName": "J", // platformName的第一个字
						"avatarColor": "#696969" // 深色对比
				},
				{
						"platformName": "aiXcoder",
						"intro": "自然语言到代码的方法级代码生成，以及多行智能代码补全",
						"link": "https://www.aixcoder.com",
						"logo": "aixcoder-icon.png",
						"sort": 326,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5F5", // 浅灰色背景
						"avatarName": "a", // platformName的第一个字
						"avatarColor": "#696969" // 深色对比
				},
				{
						"platformName": "AirOps",
						"intro": "AI SQL语句生成和修改",
						"link": "https://www.airops.com/",
						"logo": "airops-icon.png",
						"sort": 327,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5F5", // 浅灰色背景
						"avatarName": "A", // platformName的第一个字
						"avatarColor": "#696969" // 深色对比
				},
				{
						"platformName": "Imgcook",
						"intro": "阿里推出的免费设计稿智能生成前端代码",
						"link": "https://www.imgcook.com/",
						"logo": "imgcook-icon.png",
						"sort": 328,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5F5", // 浅灰色背景
						"avatarName": "I", // platformName的第一个字
						"avatarColor": "#696969" // 深色对比
				}
		]
},
{
		"categoryName": "音频工具",
		"clientUserThirdPartyAccountResponses": [
				{
						"platformName": "Suno中文",
						"intro": "高质量的AI音乐创作平台",
						"link": "https://www.suno.cn/home/#/?from=invite&invite_id=24985302",
						"logo": "微信图片_20240923221138.png",
						"sort": 329,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0C4DE", // Light Steel Blue
						"avatarName": "S", // platformName的第一个字
						"avatarColor": "#2F4F4F" // Dark Slate Gray
				},
				{
						"platformName": "Suno",
						"intro": "高质量的AI音乐创作平台",
						"link": "https://www.suno.ai/?ref=huyaai.cn",
						"logo": "suno-ai-icon.png",
						"sort": 330,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFD700", // Gold
						"avatarName": "S", // platformName的第一个字
						"avatarColor": "#8B0000" // Dark Red
				},
				// {
				// 		"platformName": "天工SkyMusic",
				// 		"intro": "昆仑万维发布的国内首个AI音乐生成大模型",
				// 		"link": "https://music.tiangong.cn/?utm_source=huyaai.cn",
				// 		"logo": "tiangong-ai-search-icon.png",
				// 		"sort": 331,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#D3D3D3", // Light Gray
				// 		"avatarName": "天", // platformName的第一个字
				// 		"avatarColor": "#00008B" // Dark Blue
				// },
				{
						"platformName": "海绵音乐",
						"intro": "字节跳动推出的免费AI音乐创作和发现平台",
						"link": "https://www.haimian.com/?utm_source=huyaai.cn",
						"logo": "haimianyinyue-logo.png",
						"sort": 332,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFB6C1", // Light Pink
						"avatarName": "海", // platformName的第一个字
						"avatarColor": "#8B4513" // Saddle Brown
				},
				{
						"platformName": "网易天音",
						"intro": "网易推出的一站式AI音乐创作工具",
						"link": "https://tianyin.163.com/",
						"logo": "tianyin-163-icon.png",
						"sort": 333,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#98FB98", // Pale Green
						"avatarName": "天", // platformName的第一个字
						"avatarColor": "#2E8B57" // Sea Green
				},
				{
						"platformName": "TME Studio",
						"intro": "腾讯音乐推出的智能音乐创作助手",
						"link": "https://y.qq.com/tme_studio/index.html#/",
						"logo": "tme-studio-icon.png",
						"sort": 334,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFDEAD", // Navajo White
						"avatarName": "T", // platformName的第一个字
						"avatarColor": "#8B008B" // Dark Magenta
				},
				{
						"platformName": "Stable Audio",
						"intro": "Stability AI最新推出的音乐生成工具",
						"link": "https://www.stableaudio.com/?utm_source=huyaai.cn",
						"logo": "stable-audio-icon.png",
						"sort": 335,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#E6E6FA", // Lavender
						"avatarName": "S", // platformName的第一个字
						"avatarColor": "#4B0082" // Indigo
				},
				{
						"platformName": "Udio",
						"intro": "免费的AI音乐创作工具，每月可生成1200首歌曲",
						"link": "https://www.udio.com/?utm_source=huyaai.cn",
						"logo": "udio-ai-icon.png",
						"sort": 336,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F0E68C", // Khaki
						"avatarName": "U", // platformName的第一个字
						"avatarColor": "#556B2F" // Dark Olive Green
				},
				{
						"platformName": "琅琅配音",
						"intro": "智能文本转语音工具",
						"link": "https://lang123.top/?rmd=64546",
						"logo": "lang123-logo.png",
						"sort": 337,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D8BFD8", // Thistle
						"avatarName": "琅", // platformName的第一个字
						"avatarColor": "#4B0082" // Indigo
				},
				{
						"platformName": "TextToSpeech",
						"intro": "完全免费的AI文字转语音工具",
						"link": "https://texttospeech.im/zh-CN?utm_source=huyaai.cn",
						"logo": "TextToSpeech-logo.png",
						"sort": 338,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFE4E1", // Misty Rose
						"avatarName": "T", // platformName的第一个字
						"avatarColor": "#8B0000" // Dark Red
				},
				{
						"platformName": "TTSMaker",
						"intro": "马克配音（MakVoice）推出的免费AI文字转语音工具",
						"link": "https://ttsmaker.cn/?utm_source=huyaai.cn",
						"logo": "TTSMaker-website.png",
						"sort": 339,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5DC", // Beige
						"avatarName": "T", // platformName的第一个字
						"avatarColor": "#8B4513" // Saddle Brown
				},
				{
						"platformName": "LOVO AI",
						"intro": "专业的AI文字转语音工具，支持500+声音和100种语言",
						"link": "https://lovo.ai/?utm_source=huyaai.cn",
						"logo": "lovo-ai-icon.png",
						"sort": 340,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#E0FFFF", // Light Cyan
						"avatarName": "L", // platformName的第一个字
						"avatarColor": "#4682B4" // Steel Blue
				},
				{
						"platformName": "讯飞智作",
						"intro": "科大讯飞推出的AI转语音和配音工具",
						"link": "https://peiyin.xunfei.cn/?utm_source=huyaai.cn",
						"logo": "peyin-xunfei-icon.png",
						"sort": 341,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFFACD", // Lemon Chiffon
						"avatarName": "讯", // platformName的第一个字
						"avatarColor": "#8B008B" // Dark Magenta
				},
				{
						"platformName": "Uberduck",
						"intro": "开源的AI语音生成社区，5000多种不同的声音",
						"link": "https://uberduck.ai/?via=huyaai.cn",
						"logo": "uberduck-icon.png",
						"sort": 342,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F0F8FF", // Alice Blue
						"avatarName": "U", // platformName的第一个字
						"avatarColor": "#000080" // Navy
				},
				// {
				// 		"platformName": "Reecho睿声",
				// 		"intro": "超拟真的中英文AI语音克隆/生成平台",
				// 		"link": "https://www.reecho.ai/?ref=huyaai.cn",
				// 		"logo": "reecho-ai-icon.png",
				// 		"sort": 343,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFEFD5", // Papaya Whip
				// 		"avatarName": "睿", // platformName的第一个字
				// 		"avatarColor": "#8B0000" // Dark Red
				// },
				{
						"platformName": "Deepgram",
						"intro": "快速低成本的AI语音文本互转API平台",
						"link": "https://deepgram.partnerlinks.io",
						"logo": "deepgram-icon.png",
						"sort": 344,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#DCDCDC", // Gainsboro
						"avatarName": "D", // platformName的第一个字
						"avatarColor": "#696969" // Dim Gray
				},
				// {
				// 		"platformName": "Audiobox",
				// 		"intro": "Meta推出的免费开源的AI语音和声音生成模型",
				// 		"link": "https://audiobox.metademolab.com/?ref=huyaai.cn",
				// 		"logo": "meta-icon.png",
				// 		"sort": 345,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#F5F5F5", // White Smoke
				// 		"avatarName": "A", // platformName的第一个字
				// 		"avatarColor": "#2F4F4F" // Dark Slate Gray
				// },
				{
						"platformName": "Resemble.ai",
						"intro": "AI人声生成工具",
						"link": "https://www.resemble.ai/",
						"logo": "resemble.ai-icon.png",
						"sort": 346,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFE4B5", // Moccasin
						"avatarName": "R", // platformName的第一个字
						"avatarColor": "#8B4513" // Saddle Brown
				},
				{
						"platformName": "Sonauto",
						"intro": "免费的AI音乐生成和歌曲创作工具",
						"link": "https://sonauto.ai/?utm_source=huyaai.cn",
						"logo": "sonauto-icon.png",
						"sort": 349,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFF5EE", // Seashell
						"avatarName": "S", // platformName的第一个字
						"avatarColor": "#8B4513" // Saddle Brown
				},
				{
						"platformName": "魔音工坊",
						"intro": "AI配音软件，轻松配出媲美真人的声音",
						"link": "https://www.moyin.com/?utm_source=huyaai.cn",
						"logo": "moyin-icon.png",
						"sort": 350,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#E6E6FA", // Lavender
						"avatarName": "魔", // platformName的第一个字
						"avatarColor": "#4B0082" // Indigo
				},
				{
						"platformName": "大饼AI变声",
						"intro": "免费专业的AI变声软件，一键实时语音变声",
						"link": "https://dubbing.tech/?ref=huyaai.cn",
						"logo": "dubbing-ai-icon.png",
						"sort": 351,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F0E68C", // Khaki
						"avatarName": "大", // platformName的第一个字
						"avatarColor": "#8B0000" // Dark Red
				},
				{
						"platformName": "Supertone Shift",
						"intro": "AI驱动的实时语音变换软件",
						"link": "https://product.supertone.ai/shift?utm_source=huyaai.cn",
						"logo": "supertone-shift-icon.png",
						"sort": 352,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5DC", // Beige
						"avatarName": "S", // platformName的第一个字
						"avatarColor": "#8B4513" // Saddle Brown
				},
				{
						"platformName": "快转字幕",
						"intro": "AI语音视频转文字和字幕的工具",
						"link": "https://www.kzzimu.com/?ref=huyaai.cn",
						"logo": "kzzimu-icon.png",
						"sort": 353,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#E0FFFF", // Light Cyan
						"avatarName": "快", // platformName的第一个字
						"avatarColor": "#4682B4" // Steel Blue
				},
				{
						"platformName": "悦音配音",
						"intro": "AI智能在线配音语音合成工具",
						"link": "https://yueyin.zhipianbang.com?utm_source=huyaai.cn",
						"logo": "yueyin-icon.png",
						"sort": 354,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFE4E1", // Misty Rose
						"avatarName": "悦", // platformName的第一个字
						"avatarColor": "#8B0000" // Dark Red
				},
				{
						"platformName": "音虫",
						"intro": "内置AI音乐编曲的音乐制作工具",
						"link": "https://www.soundbug.com/?ref=huyaai.cn",
						"logo": "soundbug-icon.png",
						"sort": 355,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D3D3D3", // Light Gray
						"avatarName": "音", // platformName的第一个字
						"avatarColor": "#00008B" // Dark Blue
				},
				{
						"platformName": "Mubert",
						"intro": "AI BGM背景音乐生成工具",
						"link": "https://mubert.com/",
						"logo": "mubert-icon.png",
						"sort": 356,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5F5", // White Smoke
						"avatarName": "M", // platformName的第一个字
						"avatarColor": "#2F4F4F" // Dark Slate Gray
				},
				{
						"platformName": "Beatoven.ai",
						"intro": "免版税AI音乐创建平台",
						"link": "https://www.beatoven.ai/",
						"logo": "beatoven-ai-icon.png",
						"sort": 357,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFE4B5", // Moccasin
						"avatarName": "B", // platformName的第一个字
						"avatarColor": "#8B4513" // Saddle Brown
				},
				{
						"platformName": "Riffusion",
						"intro": "AI生成不同风格的音乐，免费开源",
						"link": "https://www.riffusion.com/",
						"logo": "riffusion-ai-icon.png",
						"sort": 358,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#DCDCDC", // Gainsboro
						"avatarName": "R", // platformName的第一个字
						"avatarColor": "#696969" // Dim Gray
				},
				{
						"platformName": "Adobe Podcast",
						"intro": "Adobe推出的在线AI音频录制和编辑工具",
						"link": "https://podcast.adobe.com/",
						"logo": "adobe-podcast-icon.png",
						"sort": 359,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5DC", // Beige
						"avatarName": "A", // platformName的第一个字
						"avatarColor": "#8B4513" // Saddle Brown
				},
				{
						"platformName": "网易云音乐·X Studio",
						"intro": "网易云音乐与小冰智能联合推出的免费AI歌手音乐创作软件",
						"link": "https://xstudio.music.163.com/?utm_source=huyaai.cn",
						"logo": "xstudio-music-163-icon.png",
						"sort": 360,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#E6E6FA", // Lavender
						"avatarName": "X", // platformName的第一个字
						"avatarColor": "#4B0082" // Indigo
				},
				{
						"platformName": "Wondercraft",
						"intro": "AI音频内容生成工具，可创建播客有声书等",
						"link": "https://www.wondercraft.ai/?via=huyaai.cn",
						"logo": "wondercraft-icon.png",
						"sort": 361,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFE4E1", // Misty Rose
						"avatarName": "W", // platformName的第一个字
						"avatarColor": "#8B0000" // Dark Red
				},
				{
						"platformName": "听脑AI",
						"intro": "人工智能语音录音记录助手",
						"link": "https://itingnao.com/?utm_source=huyaai.cn",
						"logo": "itingnao-ai-icon.png",
						"sort": 362,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F0E68C", // Khaki
						"avatarName": "听", // platformName的第一个字
						"avatarColor": "#8B0000" // Dark Red
				},
				{
						"platformName": "Fryderyk",
						"intro": "AI音乐创作工具，集成了多种乐器声音",
						"link": "https://fryderyk.ai/?utm_source=huyaai.cn",
						"logo": "Fryderyk-website.png",
						"sort": 363,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D3D3D3", // Light Gray
						"avatarName": "F", // platformName的第一个字
						"avatarColor": "#00008B" // Dark Blue
				},
				{
						"platformName": "Voicenotes",
						"intro": "AI驱动的语音笔记工具",
						"link": "https://voicenotes.com/?utm_source=huyaai.cn",
						"logo": "voicenotes-icon.png",
						"sort": 364,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFE4B5", // Moccasin
						"avatarName": "V", // platformName的第一个字
						"avatarColor": "#8B4513" // Saddle Brown
				},
				{
						"platformName": "OptimizerAI",
						"intro": "AI声音效果生成工具",
						"link": "https://www.optimizerai.xyz/?utm_source=huyaai.cn",
						"logo": "optimizerai-icon.png",
						"sort": 365,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5F5", // White Smoke
						"avatarName": "O", // platformName的第一个字
						"avatarColor": "#2F4F4F" // Dark Slate Gray
				},
				// {
				// 		"platformName": "ACE Studio",
				// 		"intro": "AI歌声合成工具，输入歌词与旋律即可生成宛如真人的歌声",
				// 		"link": "https://ace-studio.timedomain.cn",
				// 		"logo": "ace-studio-icon.png",
				// 		"sort": 366,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFE4E1", // Misty Rose
				// 		"avatarName": "A", // platformName的第一个字
				// 		"avatarColor": "#8B0000" // Dark Red
				// },
				{
						"platformName": "蓝藻AI",
						"intro": "云知声旗下的AI配音和声音克隆平台",
						"link": "https://aigc.unisound.com/?ref=huyaai.cn",
						"logo": "aigc-unisound-icon.png",
						"sort": 367,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D3D3D3", // Light Gray
						"avatarName": "蓝", // platformName的第一个字
						"avatarColor": "#00008B" // Dark Blue
				},
				{
						"platformName": "FakeYou",
						"intro": "Deep Fake文本转语音",
						"link": "https://fakeyou.com/",
						"logo": "fakeyou-icon.png",
						"sort": 368,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFE4B5", // Moccasin
						"avatarName": "F", // platformName的第一个字
						"avatarColor": "#8B4513" // Saddle Brown
				},
				{
						"platformName": "BGM猫",
						"intro": "灵动音科技推出的AI智能生成BGM音乐",
						"link": "https://bgmcat.com/home",
						"logo": "bgmcat-icon.png",
						"sort": 369,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D3D3D3", // Light Gray
						"avatarName": "B", // platformName的第一个字
						"avatarColor": "#00008B" // Dark Blue
				},
				// {
				// 		"platformName": "BeatBot",
				// 		"intro": "输入文本提示快速生成歌曲和音乐",
				// 		"link": "https://beatbot.fm/?ref=huyaai.cn",
				// 		"logo": "beatbot-icon.png",
				// 		"sort": 370,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFE4B5", // Moccasin
				// 		"avatarName": "B", // platformName的第一个字
				// 		"avatarColor": "#8B4513" // Saddle Brown
				// },
				{
						"platformName": "Audo Studio",
						"intro": "AI音频清洗工具（噪音消除、声音平衡、音量调节）",
						"link": "https://audo.ai/",
						"logo": "audo-studio-icon.png",
						"sort": 371,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5F5", // White Smoke
						"avatarName": "A", // platformName的第一个字
						"avatarColor": "#2F4F4F" // Dark Slate Gray
				},
				{
						"platformName": "音疯",
						"intro": "做音乐，疯一点",
						"link": "https://www.yinfeng.cn/home",
						"logo": "微信图片_20241221134222.png",
						"sort": 372,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D3D3D3", // Light Gray
						"avatarName": "音", // platformName的第一个字
						"avatarColor": "#00008B" // Dark Blue
				},{
					"platformName": "IBM Watson文字转语音",
					"intro": "IBM Watson文字转语音",
					"link": "https://www.ibm.com/cloud/watson-text-to-speech",
					"logo": "ibm-watson-icon.png",
					"sort": 347,
					"instructions": "",
					"videoUrl": "",
					"username": "",
					"accounts": [],
					"backgroundColor": "#D3D3D3", // Light Gray
					"avatarName": "I", // platformName的第一个字
					"avatarColor": "#00008B" // Dark Blue
			},
			{
					"platformName": "ElevenLabs",
					"intro": "AI文本转语音，支持包含中文在内的28种语言",
					"link": "https://try.elevenlabs.io/mqbahm8egbk8",
					"logo": "elevenlabs-icon.png",
					"sort": 348,
					"instructions": "",
					"videoUrl": "",
					"username": "",
					"accounts": [],
					"backgroundColor": "#F5FFFA", // Mint Cream
					"avatarName": "E", // platformName的第一个字
					"avatarColor": "#8B0000" // Dark Red
			},
		]
},
{
		"categoryName": "内容检测",
		"clientUserThirdPartyAccountResponses": [
				{
						"platformName": "GPTZero",
						"intro": "超过百万人都在用的免费AI工具",
						"link": "https://gptzero.me/",
						"logo": "gptzero-icon-new.png",
						"sort": 373,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#A9A9A9", // Dark Gray
						"avatarName": "G", // platformName的第一个字
						"avatarColor": "#FFFFFF" // White
				},
				{
						"platformName": "StudyCorgi ChatGPT Detector",
						"intro": "免费的检测论文是否由ChatGPT生成的工具",
						"link": "https://studycorgi.com/free-writing-tools/chat-gpt-detector/",
						"logo": "studycorgi-icon.png",
						"sort": 374,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0C4DE", // Light Steel Blue
						"avatarName": "S", // platformName的第一个字
						"avatarColor": "#2F4F4F" // Dark Slate Gray
				},
				{
						"platformName": "Writecream AI Content Detector",
						"intro": "Writecream推出的AI工具",
						"link": "https://www.writecream.com/ai-content-detector/",
						"logo": "writecream-icon.png",
						"sort": 375,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D3D3D3", // Light Gray
						"avatarName": "W", // platformName的第一个字
						"avatarColor": "#696969" // Dim Gray
				},
				{
						"platformName": "Smodin AI Content Detector",
						"intro": "多语种AI工具",
						"link": "https://smodin.io/ai-content-detector",
						"logo": "smodin-icon.png",
						"sort": 376,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C0C0C0", // Silver
						"avatarName": "S", // platformName的第一个字
						"avatarColor": "#000000" // Black
				},
				{
						"platformName": "AI Content Detector",
						"intro": "Writer推出的AI工具",
						"link": "https://writer.com/ai-content-detector/",
						"logo": "writer-icon.png",
						"sort": 377,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D8BFD8", // Thistle
						"avatarName": "A", // platformName的第一个字
						"avatarColor": "#4B0082" // Indigo
				},
				{
						"platformName": "AISEO AI Content Detector",
						"intro": "AISEO推出的AI器",
						"link": "https://aiseo.ai/tools/ai-content-detector.html",
						"logo": "aiseo-ai-icon.png",
						"sort": 378,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFE4E1", // Misty Rose
						"avatarName": "A", // platformName的第一个字
						"avatarColor": "#8B0000" // Dark Red
				},
				// {
				// 		"platformName": "Proofig",
				// 		"intro": "AI检测科研图像是否造假抄袭",
				// 		"link": "https://www.proofig.com/?ref=huyaai.cn",
				// 		"logo": "proofig-ai-icon.png",
				// 		"sort": 379,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#BEBEBE", // Gray
				// 		"avatarName": "P", // platformName的第一个字
				// 		"avatarColor": "#00008B" // Dark Blue
				// },
				{
						"platformName": "Originality.AI",
						"intro": "原创度和AI",
						"link": "https://originality.ai/",
						"logo": "originality-ai-icon.png",
						"sort": 380,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5DC", // Beige
						"avatarName": "O", // platformName的第一个字
						"avatarColor": "#4B0082" // Indigo
				},
				{
						"platformName": "Sapling AI Content Detector",
						"intro": "Sapling.ai推出的免费在线AI工具",
						"link": "https://sapling.ai/utilities/ai-content-detector",
						"logo": "sapling-ai-icon.png",
						"sort": 381,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D3D3D3", // Light Gray
						"avatarName": "S", // platformName的第一个字
						"avatarColor": "#696969" // Dim Gray
				},
				{
						"platformName": "GPT Detector",
						"intro": "在线检查文本是否由GPT-3或ChatGPT生成",
						"link": "https://x.writefull.com/gpt-detector",
						"logo": "writefull-icon.png",
						"sort": 382,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C0C0C0", // Silver
						"avatarName": "G", // platformName的第一个字
						"avatarColor": "#000000" // Black
				},
				// {
				// 		"platformName": "CopyLeaks",
				// 		"intro": "AI11和分级",
				// 		"link": "https://copyleaks.com/",
				// 		"logo": "copyleaks-icon.png",
				// 		"sort": 383,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#D8BFD8", // Thistle
				// 		"avatarName": "C", // platformName的第一个字
				// 		"avatarColor": "#4B0082" // Indigo
				// },
				{
						"platformName": "Winston AI",
						"intro": "强大的AI解决方案",
						"link": "https://gowinston.ai/",
						"logo": "winston-ai-icon.png",
						"sort": 384,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#A9A9A9", // Dark Gray
						"avatarName": "W", // platformName的第一个字
						"avatarColor": "#FFFFFF" // White
				}
		]
},
{
		"categoryName": "语言翻译",
		"clientUserThirdPartyAccountResponses": [
				{
						"platformName": "阿里翻译",
						"intro": "阿里巴巴达摩院推出的多领域多语种的在线机器翻译",
						"link": "https://translate.alibaba.com/?ref=huyaai.cn",
						"logo": "translate-alibaba-icon.png",
						"sort": 385,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0C4DE", // Light Steel Blue
						"avatarName": "阿", // platformName的第一个字
						"avatarColor": "#2F4F4F" // Dark Slate Gray
				},
				{
						"platformName": "火山翻译",
						"intro": "字节跳动推出的智能翻译工具",
						"link": "https://translate.volcengine.com/",
						"logo": "translate-voclengine-icon.png",
						"sort": 386,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D3D3D3", // Light Gray
						"avatarName": "火", // platformName的第一个字
						"avatarColor": "#696969" // Dim Gray
				},
				{
						"platformName": "百度翻译",
						"intro": "200种语言互译、沟通全世界！",
						"link": "https://fanyi.baidu.com/",
						"logo": "fanyi-baidu-icon.png",
						"sort": 387,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C0C0C0", // Silver
						"avatarName": "百", // platformName的第一个字
						"avatarColor": "#000000" // Black
				},
				{
						"platformName": "腾讯翻译君",
						"intro": "你免费的随身翻译",
						"link": "https://fanyi.qq.com/",
						"logo": "fanyi-qq-icon.png",
						"sort": 388,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D8BFD8", // Thistle
						"avatarName": "腾", // platformName的第一个字
						"avatarColor": "#4B0082" // Indigo
				},
				{
						"platformName": "必应翻译",
						"intro": "微软必应推出的翻译工具",
						"link": "https://www.bing.com/translator/",
						"logo": "new-bing-icon.png",
						"sort": 389,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#A9A9A9", // Dark Gray
						"avatarName": "必", // platformName的第一个字
						"avatarColor": "#FFFFFF" // White
				},
				{
						"platformName": "DeepL翻译",
						"intro": "准确的人工智能翻译工具",
						"link": "https://www.deepl.com/translator",
						"logo": "deepl-write-icon.png",
						"sort": 390,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0E0E6", // Powder Blue
						"avatarName": "D", // platformName的第一个字
						"avatarColor": "#4682B4" // Steel Blue
				},
				{
						"platformName": "象寄翻译",
						"intro": "AI图片和视频翻译神器，支持多种语言的翻译",
						"link": "https://www.xiangjifanyi.com/console/register-invite/741be04feb30bf16",
						"logo": "xiangjifanyi-icon.png",
						"sort": 391,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFE4E1", // Misty Rose
						"avatarName": "象", // platformName的第一个字
						"avatarColor": "#8B0000" // Dark Red
				},
				{
						"platformName": "网易见外",
						"intro": "网易推出的AI智能翻译平台，支持音视频、文档、图片、字幕等翻译",
						"link": "https://sight.youdao.com/?utm_source=huyaai.cn",
						"logo": "jianwai-icon.png",
						"sort": 392,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5DC", // Beige
						"avatarName": "网", // platformName的第一个字
						"avatarColor": "#8B4513" // Saddle Brown
				},
				{
						"platformName": "Google翻译",
						"intro": "Google免费提供的上百种语言智能翻译工具",
						"link": "https://translate.google.com/",
						"logo": "google-translate-icon.png",
						"sort": 393,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D3D3D3", // Light Gray
						"avatarName": "G", // platformName的第一个字
						"avatarColor": "#696969" // Dim Gray
				},
				{
						"platformName": "TranSmart",
						"intro": "腾讯AI Lab推出的一款AI辅助翻译产品",
						"link": "https://transmart.qq.com/zh-CN/index",
						"logo": "transmart-qq-icon.png",
						"sort": 394,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0E0E6", // Powder Blue
						"avatarName": "T", // platformName的第一个字
						"avatarColor": "#4682B4" // Steel Blue
				},
				{
						"platformName": "讯飞智能翻译",
						"intro": "科大讯飞推出的人工智能翻译平台",
						"link": "https://fanyi.xfyun.cn/console/trans/text",
						"logo": "fanyi-xfyun-icon.png",
						"sort": 395,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFE4E1", // Misty Rose
						"avatarName": "讯", // platformName的第一个字
						"avatarColor": "#8B0000" // Dark Red
				},
				{
						"platformName": "搜狗翻译",
						"intro": "你的贴身智能翻译专家",
						"link": "https://fanyi.sogou.com/text",
						"logo": "fanyi-sogou-icon.png",
						"sort": 396,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5DC", // Beige
						"avatarName": "搜", // platformName的第一个字
						"avatarColor": "#8B4513" // Saddle Brown
				},
				{
						"platformName": "彩云小译",
						"intro": "兼具中日英同声传译、文档翻译和网页翻译的智能翻译工具",
						"link": "https://fanyi.caiyunapp.com/#/",
						"logo": "fanyi-caiyunapp-icon.png",
						"sort": 397,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D3D3D3", // Light Gray
						"avatarName": "彩", // platformName的第一个字
						"avatarColor": "#696969" // Dim Gray
				},
				{
						"platformName": "百度AI同传助手",
						"intro": "中英文音视频同传字幕工具",
						"link": "https://fanyi.baidu.com/appdownload/download.html?tab=helper&fr=pcproduct",
						"logo": "tongchuan-baidu-icon.png",
						"sort": 398,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0C4DE", // Light Steel Blue
						"avatarName": "百", // platformName的第一个字
						"avatarColor": "#2F4F4F" // Dark Slate Gray
				},
				{
						"platformName": "金山快译",
						"intro": "金山WPS推出的在线翻译平台",
						"link": "https://kuaiyi.wps.cn/txt-translate",
						"logo": "wps-kuaiyi-icon.png",
						"sort": 399,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D8BFD8", // Thistle
						"avatarName": "金", // platformName的第一个字
						"avatarColor": "#4B0082" // Indigo
				}
		]
},
{
		"categoryName": "法律助手",
		"clientUserThirdPartyAccountResponses": [
				{
						"platformName": "通义法睿",
						"intro": "阿里推出的免费AI法律顾问助手",
						"link": "https://tongyi.aliyun.com/farui?utm_source=huyaai.cn",
						"logo": "tongyi-icon.png",
						"sort": 400,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0E0E6", // Powder Blue
						"avatarName": "通", // platformName的第一个字
						"avatarColor": "#2F4F4F" // Dark Slate Gray
				},
				{
						"platformName": "法行宝",
						"intro": "百度推出的免费AI13",
						"link": "https://ailegal.baidu.com/?utm_source=huyaai.cn",
						"logo": "baidu-ai-law-icon.png",
						"sort": 401,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFDAB9", // Peach Puff
						"avatarName": "法", // platformName的第一个字
						"avatarColor": "#8B0000" // Dark Red
				},
				{
						"platformName": "海瑞智法",
						"intro": "一站式AI法律咨询助手",
						"link": "https://www.hairuilegal.com/?utm_source=huyaai.cn",
						"logo": "hairuilegal-icon.png",
						"sort": 402,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D3D3D3", // Light Gray
						"avatarName": "海", // platformName的第一个字
						"avatarColor": "#696969" // Dim Gray
				},
				{
						"platformName": "元典智库",
						"intro": "智能法律知识服务平台和3",
						"link": "https://www.chineselaw.com/tyjs/index?utm_source=huyaai.cn",
						"logo": "ydzk-chinese-law-icon.png",
						"sort": 403,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFE4E1", // Misty Rose
						"avatarName": "元", // platformName的第一个字
						"avatarColor": "#8B4513" // Saddle Brown
				},
				// {
				// 		"platformName": "ChatLaw",
				// 		"intro": "北大开源的法律大模型和助手",
				// 		"link": "https://chatlaw.cloud/lawchat/#/?utm_source=huyaai.cn",
				// 		"logo": "chatlaw-icon.png",
				// 		"sort": 404,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#F5F5DC", // Beige
				// 		"avatarName": "聊", // platformName的第一个字
				// 		"avatarColor": "#8B0000" // Dark Red
				// },
				{
						"platformName": "得理法搜",
						"intro": "AI法律智能检索系统",
						"link": "https://www.delilegal.com/search?utm_source=huyaai.cn",
						"logo": "delisearch-icon.png",
						"sort": 405,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D8BFD8", // Thistle
						"avatarName": "得", // platformName的第一个字
						"avatarColor": "#4B0082" // Indigo
				},
				{
						"platformName": "合同嗖嗖",
						"intro": "专业的AI法律合同生成工具",
						"link": "https://contract.yoo-ai.com/?utm_source=huyaai.cn",
						"logo": "yoo-ai-contract-icon.png",
						"sort": 406,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C0C0C0", // Silver
						"avatarName": "合", // platformName的第一个字
						"avatarColor": "#000000" // Black
				}
		]
},
{
		"categoryName": "训练模型",
		"clientUserThirdPartyAccountResponses": [
				{
						"platformName": "阿里巴巴M6",
						"intro": "阿里巴巴达摩院推出的超大规模中文预14(M6)",
						"link": "https://m6.aliyun.com/#/",
						"logo": "aliyun-icon.png",
						"sort": 407,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0C4DE", // Light Steel Blue
						"avatarName": "阿", // platformName的第一个字
						"avatarColor": "#2F4F4F" // Dark Slate Gray
				},
				// {
				// 		"platformName": "Sora",
				// 		"intro": "OpenAI推出的AI文本到视频生成模型",
				// 		"link": "https://openai.com/sora?ref=huyaai.cn",
				// 		"logo": "openai-gpt-model.png",
				// 		"sort": 408,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#D3D3D3", // Light Gray
				// 		"avatarName": "S", // platformName的第一个字
				// 		"avatarColor": "#696969" // Dim Gray
				// },
				{
						"platformName": "Stable Diffusion",
						"intro": "StabilityAI推出的文本到图像生成AI",
						"link": "https://www.diffus.me/?utm_source=google&utm_medium=ad&utm_campaign=as-ch-em-diffus&utm_agid=165164580618&utm_term=stable+diffusion&creative=704531323164&device=c&placement=&gad_source=1&gclid=EAIaIQobChMI8LCjl9qTjAMVLgGtBh1xgjT0EAAYAiAAEgLA4vD_BwE",
						"logo": "stability-ai-icon.png",
						"sort": 409,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#C0C0C0", // Silver
						"avatarName": "S", // platformName的第一个字
						"avatarColor": "#000080" // Navy
				},
				{
						"platformName": "GPT-4o",
						"intro": "OpenAI最新发布的多模态AI大模型，可自然流畅地进行语音对话",
						"link": "https://openai.com/index/hello-gpt-4o/",
						"logo": "openai-gpt-model.png",
						"sort": 410,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFD700", // Gold
						"avatarName": "G", // platformName的第一个字
						"avatarColor": "#8B0000" // Dark Red
				},
				{
						"platformName": "腾讯混元大模型",
						"intro": "腾讯研发的大语言模型，具备强大的中文创作能力，复杂语境下的逻辑推理能力，以及可靠的任务执行能力",
						"link": "https://hunyuan.tencent.com/?utm_source=huyaai.cn",
						"logo": "hunyuan-tencent-icon.png",
						"sort": 411,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFB6C1", // Light Pink
						"avatarName": "腾", // platformName的第一个字
						"avatarColor": "#4B0082" // Indigo
				},
				{
						"platformName": "Llama 3",
						"intro": "Meta最新开源推出的新一代大模型",
						"link": "https://llama.meta.com/llama3/?utm_source=huyaai.cn",
						"logo": "meta-icon.png",
						"sort": 412,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#E6E6FA", // Lavender
						"avatarName": "L", // platformName的第一个字
						"avatarColor": "#8B4513" // Saddle Brown
				},
				// {
				// 		"platformName": "Gemma",
				// 		"intro": "谷歌推出的新一代轻量级开放模型",
				// 		"link": "https://ai.google.dev/gemma?hl=zh-cn",
				// 		"logo": "google-gemma-icon.png",
				// 		"sort": 413,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#F5F5DC", // Beige
				// 		"avatarName": "G", // platformName的第一个字
				// 		"avatarColor": "#8B0000" // Dark Red
				// },
				// {
				// 		"platformName": "Coze",
				// 		"intro": "字节推出的AI机器人和智能体创建平台",
				// 		"link": "https://www.coze.cn",
				// 		"logo": "coze-ai-icon.png",
				// 		"sort": 414,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#D8BFD8", // Thistle
				// 		"avatarName": "C", // platformName的第一个字
				// 		"avatarColor": "#4B0082" // Indigo
				// },
				// {
				// 		"platformName": "GPT-4",
				// 		"intro": "OpenAI旗下最新的GPT-4模型",
				// 		"link": "https://cn.bing.com/search?q=GPT-4&ensearch=1",
				// 		"logo": "gpt-4-icon.png",
				// 		"sort": 415,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFE4E1", // Misty Rose
				// 		"avatarName": "G", // platformName的第一个字
				// 		"avatarColor": "#8B0000" // Dark Red
				// },
				{
						"platformName": "DALL·E 3",
						"intro": "OpenAI旗下最新的图像生成模型",
						"link": "https://openai.com/index/dall-e-3/",
						"logo": "dall-e-2-icon.png",
						"sort": 416,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F0E68C", // Khaki
						"avatarName": "D", // platformName的第一个字
						"avatarColor": "#8B0000" // Dark Red
				},
				{
						"platformName": "文心大模型",
						"intro": "百度推出的产业级知识增强大模型",
						"link": "https://wenxin.baidu.com/",
						"logo": "paddlepaddle-icon.png",
						"sort": 417,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D3D3D3", // Light Gray
						"avatarName": "文", // platformName的第一个字
						"avatarColor": "#00008B" // Dark Blue
				},
				// {
				// 		"platformName": "LLaMA",
				// 		"intro": "Meta（Facebook）推出的AI大语言模型",
				// 		"link": "https://github.com/facebookresearch/llama",
				// 		"logo": "meta-icon.png",
				// 		"sort": 418,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#B0E0E6", // Powder Blue
				// 		"avatarName": "L", // platformName的第一个字
				// 		"avatarColor": "#8B4513" // Saddle Brown
				// },
				{
						"platformName": "Auto-GPT",
						"intro": "爆火的实现GPT-4完全自主的实验性开源项目，GitHub超10万星",
						"link": "https://agpt.co/",
						"logo": "autogpt-icon.png",
						"sort": 419,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFEFD5", // Papaya Whip
						"avatarName": "A", // platformName的第一个字
						"avatarColor": "#8B0000" // Dark Red
				},
				// {
				// 		"platformName": "Jan",
				// 		"intro": "本地运行大模型并进行AI对话的工具，免费开源",
				// 		"link": "https://jan.ai/?ref=huyaai.cn",
				// 		"logo": "jan-ai-icon.png",
				// 		"sort": 420,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#E0FFFF", // Light Cyan
				// 		"avatarName": "J", // platformName的第一个字
				// 		"avatarColor": "#00008B" // Dark Blue
				// },
				// {
				// 		"platformName": "AgentGPT",
				// 		"intro": "在浏览器中组装、配置和部署自主人工智能的开源项目",
				// 		"link": "https://agentgpt.reworkd.ai/",
				// 		"logo": "agentgpt-icon.png",
				// 		"sort": 421,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#F5F5F5", // White Smoke
				// 		"avatarName": "A", // platformName的第一个字
				// 		"avatarColor": "#8B0000" // Dark Red
				// },
				{
						"platformName": "Ollama",
						"intro": "本地运行Llama和其他大语言模型",
						"link": "https://ollama.ai/?ref=huyaai.cn",
						"logo": "ollama-icon.png",
						"sort": 422,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D8BFD8", // Thistle
						"avatarName": "O", // platformName的第一个字
						"avatarColor": "#4B0082" // Indigo
				},
				{
						"platformName": "魔搭社区",
						"intro": "阿里达摩院推出的AI模型社区，超过300+开源AI模型",
						"link": "https://www.modelscope.cn/",
						"logo": "modelscope-icon.png",
						"sort": 423,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#E6E6FA", // Lavender
						"avatarName": "魔", // platformName的第一个字
						"avatarColor": "#8B4513" // Saddle Brown
				},
				// {
				// 		"platformName": "悟道",
				// 		"intro": "智源“悟道”大模型，中国首个+世界最大人工智能大模型",
				// 		"link": "https://www.baai.ac.cn/portal/article/index/cid/49/id/518.html",
				// 		"logo": "wudao-icon.png",
				// 		"sort": 424,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#F0E68C", // Khaki
				// 		"avatarName": "悟", // platformName的第一个字
				// 		"avatarColor": "#8B0000" // Dark Red
				// },
				// {
				// 		"platformName": "序列猴子",
				// 		"intro": "出门问问推出的一款超大规模的语言模型",
				// 		"link": "https://openapi.mobvoi.com/index",
				// 		"logo": "openapi-mobvoi-icon.png",
				// 		"sort": 425,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#B0E0E6", // Powder Blue
				// 		"avatarName": "序", // platformName的第一个字
				// 		"avatarColor": "#8B4513" // Saddle Brown
				// },
				{
						"platformName": "BLOOM",
						"intro": "HuggingFace推出的大型语言模型（LLM）",
						"link": "https://huggingface.co/docs/transformers/model_doc/bloom",
						"logo": "bloom-icon.png",
						"sort": 426,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D3D3D3", // Light Gray
						"avatarName": "B", // platformName的第一个字
						"avatarColor": "#00008B" // Dark Blue
				},
				// {
				// 		"platformName": "Lamini",
				// 		"intro": "低门槛快速定制大语言模型的引擎",
				// 		"link": "https://lamini.ai/",
				// 		"logo": "lamini-ai-icon.png",
				// 		"sort": 427,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFE4E1", // Misty Rose
				// 		"avatarName": "L", // platformName的第一个字
				// 		"avatarColor": "#8B0000" // Dark Red
				// },
				{
						"platformName": "StableLM",
						"intro": "Stability AI推出的开源的类ChatGPT大语言模型",
						"link": "https://github.com/Stability-AI/StableLM",
						"logo": "stablelm-icon.png",
						"sort": 428,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0C4DE", // Light Steel Blue
						"avatarName": "S", // platformName的第一个字
						"avatarColor": "#2F4F4F" // Dark Slate Gray
				},
				{
						"platformName": "Gen-2",
						"intro": "Runway最新推出的AI视频生成模型",
						"link": "https://research.runwayml.com/gen2",
						"logo": "runwayml-icon.png",
						"sort": 429,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D8BFD8", // Thistle
						"avatarName": "G", // platformName的第一个字
						"avatarColor": "#4B0082" // Indigo
				},
				{
						"platformName": "DeepSpeed",
						"intro": "微软开源的低成本实现类似ChatGPT的模型训练",
						"link": "https://www.deepspeed.ai/",
						"logo": "deepspeed-icon.png",
						"sort": 430,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFEFD5", // Papaya Whip
						"avatarName": "D", // platformName的第一个字
						"avatarColor": "#8B0000" // Dark Red
				},
				{
						"platformName": "MiracleVision奇想智能",
						"intro": "美图推出的AI视觉大模型，支持AI图像、设计和视频创作",
						"link": "https://www.miraclevision.com/?ref=huyaai.cn",
						"logo": "miraclevision-icon.png",
						"sort": 431,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5F5", // White Smoke
						"avatarName": "奇", // platformName的第一个字
						"avatarColor": "#8B0000" // Dark Red
				},
				{
						"platformName": "Gradio",
						"intro": "开源的搭建机器学习模型UI界面的Python库",
						"link": "https://gradio.app/",
						"logo": "gradio-icon.png",
						"sort": 432,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D3D3D3", // Light Gray
						"avatarName": "G", // platformName的第一个字
						"avatarColor": "#00008B" // Dark Blue
				},
				// {
				// 		"platformName": "DeepFloyd IF",
				// 		"intro": "StabilityAI旗下的DeepFloyd团队推出的图片生成模型",
				// 		"link": "https://deepfloyd.ai/deepfloyd-if",
				// 		"logo": "deepfloyd-icon.png",
				// 		"sort": 433,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFE4E1", // Misty Rose
				// 		"avatarName": "D", // platformName的第一个字
				// 		"avatarColor": "#8B0000" // Dark Red
				// },
				// {
				// 		"platformName": "Cohere",
				// 		"intro": "构建AI产品的大语言模型平台",
				// 		"link": "https://cohere.com/",
				// 		"logo": "cohere-icon.png",
				// 		"sort": 434,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#B0C4DE", // Light Steel Blue
				// 		"avatarName": "C", // platformName的第一个字
				// 		"avatarColor": "#2F4F4F" // Dark Slate Gray
				// },
				{
						"platformName": "Segment Anything（SAM）",
						"intro": "Meta最新推出的AI图像分割模型",
						"link": "https://segment-anything.com/",
						"logo": "meta-icon.png",
						"sort": 435,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D8BFD8", // Thistle
						"avatarName": "S", // platformName的第一个字
						"avatarColor": "#4B0082" // Indigo
				},
				{
						"platformName": "HuggingFace",
						"intro": "AI模型开发社区",
						"link": "https://huggingface.co/",
						"logo": "huggingface-icon.png",
						"sort": 436,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F5F5F5", // White Smoke
						"avatarName": "H", // platformName的第一个字
						"avatarColor": "#8B0000" // Dark Red
				},
				// {
				// 		"platformName": "天壤小白",
				// 		"intro": "灵活的AI应用构建和开发平台",
				// 		"link": "https://www.tianrang.com/?ref=huyaai.cn",
				// 		"logo": "tianrang-icon.png",
				// 		"sort": 437,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#E6E6FA", // Lavender
				// 		"avatarName": "天", // platformName的第一个字
				// 		"avatarColor": "#8B4513" // Saddle Brown
				// },
				{
						"platformName": "Imagen",
						"intro": "Google AI文字到图像生成模型",
						"link": "https://imagen.research.google/",
						"logo": "google-icon.png",
						"sort": 438,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#F0E68C", // Khaki
						"avatarName": "I", // platformName的第一个字
						"avatarColor": "#8B0000" // Dark Red
				},
				// {
				// 		"platformName": "StableVicuna",
				// 		"intro": "第一个通过RLHF训练的大规模开源聊天机器人",
				// 		"link": "https://chat.lmsys.org/",
				// 		"logo": "stablevicuna-icon.png",
				// 		"sort": 439,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#B0C4DE", // Light Steel Blue
				// 		"avatarName": "S", // platformName的第一个字
				// 		"avatarColor": "#2F4F4F" // Dark Slate Gray
				// },
				// {
				// 		"platformName": "Codex",
				// 		"intro": "OpenAI旗下AI代码生成14",
				// 		"link": "https://openai.com/blog/openai-codex",
				// 		"logo": "openai-codex-icon.png",
				// 		"sort": 440,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFE4E1", // Misty Rose
				// 		"avatarName": "C", // platformName的第一个字
				// 		"avatarColor": "#8B0000" // Dark Red
				// },
				{
						"platformName": "PaLM 2",
						"intro": "Google的下一代大语言模型，超过3400亿参数",
						"link": "https://ai.google/discover/palm2",
						"logo": "palm2-icon.png",
						"sort": 441,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D3D3D3", // Light Gray
						"avatarName": "P", // platformName的第一个字
						"avatarColor": "#00008B" // Dark Blue
				},
				// {
				// 		"platformName": "OpenBMB",
				// 		"intro": "清华团队支持发起的大规模预训练语言模型库与相关工具",
				// 		"link": "https://www.openbmb.org/home",
				// 		"logo": "openbmb-icon.png",
				// 		"sort": 442,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFE4E1", // Misty Rose
				// 		"avatarName": "O", // platformName的第一个字
				// 		"avatarColor": "#8B0000" // Dark Red
				// },
				// {
				// 		"platformName": "Watsonx.ai",
				// 		"intro": "IBM推出的企业级生成式人工智能和机器学习平台",
				// 		"link": "https://www.ibm.com/products/watsonx-ai",
				// 		"logo": "watsonx-ai-icon.png",
				// 		"sort": 443,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#D8BFD8", // Thistle
				// 		"avatarName": "W", // platformName的第一个字
				// 		"avatarColor": "#4B0082" // Indigo
				// },
				// {
				// 		"platformName": "Lobe",
				// 		"intro": "简单免费的机器学习模型训练工具",
				// 		"link": "https://www.lobe.ai/",
				// 		"logo": "lobe-ai-icon.png",
				// 		"sort": 444,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#FFE4E1", // Misty Rose
				// 		"avatarName": "L", // platformName的第一个字
				// 		"avatarColor": "#8B0000" // Dark Red
				// },
				{
						"platformName": "Scale AI",
						"intro": "AI机器学习标注训练平台",
						"link": "https://scale.com/",
						"logo": "scale-ai-icon.png",
						"sort": 445,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0C4DE", // Light Steel Blue
						"avatarName": "S", // platformName的第一个字
						"avatarColor": "#2F4F4F" // Dark Slate Gray
				},
				// {
				// 		"platformName": "MOSS",
				// 		"intro": "复旦大学团队开发的对话式大型语言模型",
				// 		"link": "https://moss.fastnlp.top/",
				// 		"logo": "moss-icon.png",
				// 		"sort": 446,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#D3D3D3", // Light Gray
				// 		"avatarName": "M", // platformName的第一个字
				// 		"avatarColor": "#00008B" // Dark Blue
				// },
				{
						"platformName": "Replicate",
						"intro": "在线运行开源机器学习模型",
						"link": "https://replicate.com/",
						"logo": "replicate-icon.png",
						"sort": 447,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFE4E1", // Misty Rose
						"avatarName": "R", // platformName的第一个字
						"avatarColor": "#8B0000" // Dark Red
				},
				// {
				// 		"platformName": "商量SenseChat",
				// 		"intro": "商汤科技推出的类ChatGPT的人工智能大语言模型",
				// 		"link": "https://chat.sensetime.com/wb/",
				// 		"logo": "sensechat-icon.png",
				// 		"sort": 448,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#D8BFD8", // Thistle
				// 		"avatarName": "商", // platformName的第一个字
				// 		"avatarColor": "#4B0082" // Indigo
				// }
		]
},
{
		"categoryName": "模型评测",
		"clientUserThirdPartyAccountResponses": [
				{
						"platformName": "MMLU",
						"intro": "大规模多任务语言理解基准",
						"link": "https://paperswithcode.com/sota/multi-task-language-understanding-on-mmlu",
						"logo": "mmlu-benchmark-icon.png",
						"sort": 449,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#A9A9A9", // Dark Gray
						"avatarName": "M", // platformName的第一个字
						"avatarColor": "#FFFFFF" // White
				},
				{
						"platformName": "SuperCLUE",
						"intro": "中文通用大模型综合性测评基准",
						"link": "https://www.cluebenchmarks.com/static/superclue.html",
						"logo": "superclue-icon.png",
						"sort": 450,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0E0E6", // Powder Blue
						"avatarName": "S", // platformName的第一个字
						"avatarColor": "#2F4F4F" // Dark Slate Gray
				},
				{
						"platformName": "OpenCompass",
						"intro": "上海人工智能实验室推出的大模型开放评测体系",
						"link": "https://opencompass.org.cn/leaderboard-llm",
						"logo": "opencompass-icon.png",
						"sort": 451,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D3D3D3", // Light Gray
						"avatarName": "O", // platformName的第一个字
						"avatarColor": "#00008B" // Dark Blue
				},
				{
						"platformName": "CMMLU",
						"intro": "一个综合性的大模型中文评估基准",
						"link": "https://github.com/haonan-li/CMMLU/",
						"logo": "cmmlu-benchmark-icon.png",
						"sort": 452,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFE4E1", // Misty Rose
						"avatarName": "C", // platformName的第一个字
						"avatarColor": "#8B0000" // Dark Red
				},
				{
						"platformName": "Open LLM Leaderboard",
						"intro": "Hugging Face推出的开源大模型排行榜单",
						"link": "https://huggingface.co/spaces/HuggingFaceH4/open_llm_leaderboard",
						"logo": "huggingface-icon.png",
						"sort": 453,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#D8BFD8", // Thistle
						"avatarName": "O", // platformName的第一个字
						"avatarColor": "#4B0082" // Indigo
				},
				{
						"platformName": "C-Eval",
						"intro": "一个全面的中文基础模型评估套件",
						"link": "https://cevalbenchmark.com/static/leaderboard_zh.html",
						"logo": "c-eval-icon.png",
						"sort": 454,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0C4DE", // Light Steel Blue
						"avatarName": "C", // platformName的第一个字
						"avatarColor": "#2F4F4F" // Dark Slate Gray
				},
				// {
				// 		"platformName": "FlagEval",
				// 		"intro": "智源研究院推出的FlagEval（天秤）大15平台",
				// 		"link": "https://flageval.baai.ac.cn/#/trending",
				// 		"logo": "flageval-icon.png",
				// 		"sort": 455,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#D3D3D3", // Light Gray
				// 		"avatarName": "F", // platformName的第一个字
				// 		"avatarColor": "#00008B" // Dark Blue
				// },
				{
						"platformName": "MMBench",
						"intro": "全方位的多模态大模型能力评测体系",
						"link": "https://mmbench.opencompass.org.cn/leaderboard",
						"logo": "mmbench-icon.png",
						"sort": 456,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#FFE4E1", // Misty Rose
						"avatarName": "M", // platformName的第一个字
						"avatarColor": "#8B0000" // Dark Red
				},
				// {
				// 		"platformName": "HELM",
				// 		"intro": "斯坦福大学推出的大15体系",
				// 		"link": "https://crfm.stanford.edu/helm/latest/",
				// 		"logo": "helm-benchmark.png",
				// 		"sort": 457,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#A9A9A9", // Dark Gray
				// 		"avatarName": "H", // platformName的第一个字
				// 		"avatarColor": "#FFFFFF" // White
				// },
				// {
				// 		"platformName": "Chatbot Arena",
				// 		"intro": "以众包方式进行匿名随机对战的LLM基准平台",
				// 		"link": "https://chat.lmsys.org/",
				// 		"logo": "lmsys-icon.png",
				// 		"sort": 458,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#B0E0E6", // Powder Blue
				// 		"avatarName": "C", // platformName的第一个字
				// 		"avatarColor": "#2F4F4F" // Dark Slate Gray
				// },
				// {
				// 		"platformName": "LLMEval3",
				// 		"intro": "由复旦大学NLP实验室推出的大15基准",
				// 		"link": "http://llmeval.com/index",
				// 		"logo": "llm-eval-icon.png",
				// 		"sort": 459,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#D8BFD8", // Thistle
				// 		"avatarName": "L", // platformName的第一个字
				// 		"avatarColor": "#4B0082" // Indigo
				// },
				// {
				// 		"platformName": "H2O EvalGPT",
				// 		"intro": "H2O.ai推出的基于Elo评级方法的大模型评估系统",
				// 		"link": "https://evalgpt.ai/",
				// 		"logo": "h2o-evalgpt-icon.png",
				// 		"sort": 460,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": [],
				// 		"backgroundColor": "#A9A9A9", // Dark Gray
				// 		"avatarName": "H", // platformName的第一个字
				// 		"avatarColor": "#FFFFFF" // White
				// },
				{
						"platformName": "PubMedQA",
						"intro": "生物医学研究问答数据集和模型得分排行榜",
						"link": "https://pubmedqa.github.io/",
						"logo": "pubmedqa-icon.png",
						"sort": 461,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": [],
						"backgroundColor": "#B0C4DE", // Light Steel Blue
						"avatarName": "P", // platformName的第一个字
						"avatarColor": "#2F4F4F" // Dark Slate Gray
				}
		]
},
{
		"categoryName": "学习网站",
		"clientUserThirdPartyAccountResponses": [
				{
						"platformName": "阿里云AI学习路线",
						"intro": "阿里云推出的人工智能学习路线（学+测）",
						"link": "https://developer.aliyun.com/learning/roadmap/ai",
						"logo": "aliyun-icon.png",
						"sort": 462,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				// {
				// 		"platformName": "fast.ai",
				// 		"intro": "免费开源的深度学习和AI16，让每个人都参与到AI！",
				// 		"link": "https://www.fast.ai/",
				// 		"logo": "fast-ai-icon.png",
				// 		"sort": 463,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": []
				// },
				{
						"platformName": "动手学深度学习",
						"intro": "动手学深度学习的教材和课程",
						"link": "https://zh.d2l.ai/",
						"logo": "d2l-icon.png",
						"sort": 464,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				{
						"platformName": "MachineLearningMastery",
						"intro": "免费在线学习机器学习，从基础到高级",
						"link": "https://machinelearningmastery.com/start-here/",
						"logo": "machinelearningmastery-icon.png",
						"sort": 465,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				// {
				// 		"platformName": "Kaggle",
				// 		"intro": "机器学习和数据科学社区",
				// 		"link": "https://www.kaggle.com/",
				// 		"logo": "kaggle-icon.png",
				// 		"sort": 466,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": []
				// },
				{
						"platformName": "Coursera",
						"intro": "众多人工智能和机器学习资源",
						"link": "https://www.coursera.org/collections/best-machine-learning-ai",
						"logo": "coursera-icon.png",
						"sort": 467,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				{
						"platformName": "Elements of AI",
						"intro": "免费在线AI通识学习",
						"link": "https://www.elementsofai.com/",
						"logo": "elements-of-ai-icon.png",
						"sort": 468,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				{
						"platformName": "DeepLearning.AI",
						"intro": "深度学习和人工智能学习平台",
						"link": "https://www.deeplearning.ai/",
						"logo": "deeplearning-ai-icon.png",
						"sort": 469,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				{
						"platformName": "神经网络入门",
						"intro": "Brilliant推出的Introduction to Neural Networks课程",
						"link": "https://brilliant.org/courses/intro-neural-networks/",
						"logo": "brilliant-intro-neural-networks.png",
						"sort": 470,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				{
						"platformName": "Trancy",
						"intro": "AI驱动的语言学习工具",
						"link": "https://trancy.org/zh-cn?referrer=65803e3f65752510b033ade9",
						"logo": "trancy-ai-icon.png",
						"sort": 471,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				{
						"platformName": "Reading Coach",
						"intro": "微软推出的免费个性化AI阅读学习教练",
						"link": "https://coach.microsoft.com/?ref=huyaai.cn",
						"logo": "reading-coach-icon.png",
						"sort": 472,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				{
						"platformName": "飞桨AI Studio",
						"intro": "人工智能学习实训社区",
						"link": "https://aistudio.baidu.com/",
						"logo": "paddlepaddle-icon.png",
						"sort": 473,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				{
						"platformName": "AI大学堂",
						"intro": "科大讯飞推出的AI大学堂，学习AI、走进未来",
						"link": "https://www.aidaxue.com/",
						"logo": "aidaxue-icon.png",
						"sort": 474,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				// {
				// 		"platformName": "Generative AI for Beginners",
				// 		"intro": "微软推出的面向初学者的免费生成式人工智能课程",
				// 		"link": "https://microsoft.github.io/generative-ai-for-beginners/#/translation/cn/",
				// 		"logo": "genai-for-beginners-icon.png",
				// 		"sort": 475,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": []
				// },
				// {
				// 		"platformName": "ML for Beginners",
				// 		"intro": "微软推出的免费开源的机器学习课程，GitHub标星4万+",
				// 		"link": "https://microsoft.github.io/ML-For-Beginners/",
				// 		"logo": "ml-for-beginners-icon.png",
				// 		"sort": 476,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": []
				// },
				{
						"platformName": "Udacity AI学院",
						"intro": "Udacity推出的School of AI，从入门到高级",
						"link": "https://www.udacity.com/school/school-of-ai",
						"logo": "udacity-icon.png",
						"sort": 477,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				// {
				// 		"platformName": "Google AI",
				// 		"intro": "Google AI学习平台",
				// 		"link": "https://ai.google/",
				// 		"logo": "google-ai-icon.png",
				// 		"sort": 478,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": []
				// },
				{
						"platformName": "ShowMeAI知识社区",
						"intro": "人工智能领域的资料库和学习社区",
						"link": "https://www.showmeai.tech/?ref=huyaai.cn",
						"logo": "showmeai-icon.png",
						"sort": 479,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				{
						"platformName": "txyz",
						"intro": "AI文献阅读和学术研究辅助平台",
						"link": "https://www.txyz.ai/?utm_source=huyaai.cn",
						"logo": "txyz-ai-icon.png",
						"sort": 480,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				}
		]
},
{
		"categoryName": "应用开发",
		"clientUserThirdPartyAccountResponses": [
				{
						"platformName": "文心智能体平台",
						"intro": "百度推出的智能体构建平台",
						"link": "https://agents.baidu.com/?utm_source=huyaai.cn",
						"logo": "baidu-yiyan-icon.png",
						"sort": 481,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				{
						"platformName": "飞桨PaddlePaddle",
						"intro": "产业实践的开源深度学习平台",
						"link": "https://www.paddlepaddle.org.cn/",
						"logo": "paddlepaddle-icon.png",
						"sort": 482,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				// {
				// 		"platformName": "TensorFlow",
				// 		"intro": "Google推出的机器学习和人工智能开源库",
				// 		"link": "https://www.tensorflow.org/?hl=zh-cn",
				// 		"logo": "tensorflow-icon.png",
				// 		"sort": 483,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": []
				// },
				// {
				// 		"platformName": "PyTorch",
				// 		"intro": "开源机器学习框架",
				// 		"link": "https://pytorch.org/",
				// 		"logo": "pytorch-icon.png",
				// 		"sort": 484,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": []
				// },
				// {
				// 		"platformName": "昇思MindSpore",
				// 		"intro": "华为开源自研AI深度学习框架",
				// 		"link": "https://www.mindspore.cn/",
				// 		"logo": "mindspore-icon.png",
				// 		"sort": 485,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": []
				// },
				{
						"platformName": "Apache MXNet",
						"intro": "免费开源的深度学习框架",
						"link": "https://mxnet.apache.org/",
						"logo": "apache-mxnet-icon.png",
						"sort": 486,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				// {
				// 		"platformName": "Scikit-learn",
				// 		"intro": "Python机器学习库",
				// 		"link": "https://scikit-learn.org/",
				// 		"logo": "scikit-learn-icon.png",
				// 		"sort": 487,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": []
				// },
				// {
				// 		"platformName": "MLX",
				// 		"intro": "苹果推出的开源机器学习框架，专为Apple Silicon芯片设计",
				// 		"link": "https://ml-explore.github.io/mlx/build/html/index.html",
				// 		"logo": "mlx-icon.png",
				// 		"sort": 488,
				// 		"instructions": "",
				// 		"videoUrl": "",
				// 		"username": "",
				// 		"accounts": []
				// },
				{
						"platformName": "Label Studio",
						"intro": "免费开源的数据标注工具",
						"link": "https://labelstud.io/",
						"logo": "label-studio-icon.png",
						"sort": 489,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				{
						"platformName": "Vercel AI SDK",
						"intro": "Vercel开源的搭建AI聊天机器人的开发套件",
						"link": "https://sdk.vercel.ai/docs?utm_source=huyaai.cn",
						"logo": "vercel-icon.png",
						"sort": 490,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				{
						"platformName": "Keras",
						"intro": "Python版本的TensorFlow深度学习API",
						"link": "https://keras.io/",
						"logo": "keras-icon.png",
						"sort": 491,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				{
						"platformName": "Caffe",
						"intro": "UC伯克利研究推出的深度学习框架",
						"link": "https://caffe.berkeleyvision.org/",
						"logo": "caffe-framework.png",
						"sort": 492,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				{
						"platformName": "NumPy",
						"intro": "Python科学计算必备的包",
						"link": "https://numpy.org/",
						"logo": "numpy-icon.png",
						"sort": 493,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				{
						"platformName": "言犀智能体平台",
						"intro": "京东推出的一站式AI智能体开发平台",
						"link": "https://yanxi.jd.com/?utm_source=huyaai.cn",
						"logo": "yanxi-website.png",
						"sort": 494,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				{
						"platformName": "DL4J",
						"intro": "开源的使用JVM部署和训练深度学习模型的套件",
						"link": "https://deeplearning4j.konduit.ai/",
						"logo": "dl4j-icon.png",
						"sort": 495,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				{
						"platformName": "JAX",
						"intro": "Google推出的用于变换数值函数的机器学习框架",
						"link": "https://jax.readthedocs.io/en/latest/",
						"logo": "google-jax-icon.png",
						"sort": 496,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				{
						"platformName": "NLTK",
						"intro": "Python自然语言处理工具包",
						"link": "https://www.nltk.org/",
						"logo": "nltk-icon.png",
						"sort": 497,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				{
						"platformName": "LangChain",
						"intro": "开发由语言模型驱动的应用程序的框架",
						"link": "https://docs.langchain.com/docs/",
						"logo": "langchain-icon.png",
						"sort": 498,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				{
						"platformName": "Lightning AI",
						"intro": "快速训练、部署和开发人工智能产品的深度学习框架，由Pytorch Lightning团队推出",
						"link": "https://lightning.ai/?ref=huyaai.cn",
						"logo": "lightning-ai-icon.png",
						"sort": 499,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				},
				{
						"platformName": "Leap",
						"intro": "将AI快速集成到你自己的应用中",
						"link": "https://www.tryleap.ai/?utm_source=huyaai.cn",
						"logo": "tryleap-ai-icon.png",
						"sort": 500,
						"instructions": "",
						"videoUrl": "",
						"username": "",
						"accounts": []
				}
		]
}
]
